const zh = {
  "swap-crypto-sans-frais": {
    title: "无额外服务费的加密货币兑换：Lumina 不添加的费用以及真正构成成本的因素",
    meta: "Lumina 不会为您的兑换添加额外的自有服务费。了解真正构成兑换成本的六个组成部分：合作伙伴支付给 Lumina 的商业佣金、合作伙伴的利润、网络费用、点差、滑点和价格影响。",
    body: `您有时会看到"无费用加密货币兑换"的说法。这种表述可能会产生误导：它描述的是钱包不添加额外服务费，而不是没有任何成本。加密货币兑换仍然是一项市场操作，包含几个独立于 Lumina 的成本组成部分。

## 明确的摘要

Lumina 不会为您的兑换添加自有的额外服务费。Lumina 可能会从兑换合作伙伴处获得商业佣金。报价可能包括合作伙伴的定价条款、点差、滑点、价格影响和网络费用。汇率和预计收到的金额将在您确认之前显示。

## 兑换成本的六个组成部分

要了解您实际支付的费用，必须区分六个要素：

### 1. Lumina 添加的服务费

Lumina 在交易合作伙伴提供的报价之上**不添加**任何服务费。向您显示的金额已经反映了这种没有加价的情况。

### 2. Lumina 收到的商业佣金

Lumina 可能会从兑换合作伙伴处获得商业佣金。这项佣金不是由 Lumina 作为报价之上的单独费用项添加的。然而，它可能会反映在合作伙伴提供的定价条款中。

### 3. 交易合作伙伴的费用或利润

交易合作伙伴可能会收取自己的运营费用和自己的利润。这些要素被纳入报价中显示的汇率和预计金额中，在您确认之前。

### 4. 网络费用（gas fees）

网络费用补偿处理交易的矿工或验证者。它们根据区块链及其拥堵情况而变化。视所采用的兑换流程而定，网络费用可能以估算值显示、与其他项目合并计入，或列示在合作伙伴的报价中。

### 5. 点差

点差是流动性来源显示的买入价格与卖出价格之间的差额。这是一项隐性成本：您不会将其视为费用项目，但它直接影响应用于您兑换的汇率。

### 6. 滑点和价格影响

- **滑点**是报价时估算的汇率与执行时实际获得的汇率之间的差异。当可用流动性减少时，滑点会增加。
- **价格影响**是您自己的订单对价格的影响：您的金额相对于流动性越大，价格对您来说就越差。

这两个要素可能会改变您最终收到的金额，与初始估算相比。

## Lumina 在您确认之前显示的内容

在您确认之前，Lumina 会显示合作伙伴通报的预计汇率和金额，以及报价中可用的定价信息。当相关兑换流程提供或估算网络费用时，将显示网络费用。

是否确认交易由您决定：查看报价后，您可以确认或取消。

## 如何在 Lumina Wallet 中进行兑换

1. 在应用中打开 **Swap** 选项卡。
2. 选择您要兑换的代币和要收到的代币。
3. 输入要兑换的金额。
4. 查看显示的报价：预计汇率和金额，以及可用的定价信息（包括在提供或估算时的网络费用）。
5. 如果报价合适，请确认交易。否则，取消并调整。

## 要记住

加密货币兑换从来都不是完全免费的，即使钱包本身不添加服务费。实际成本取决于合作伙伴、网络、点差、滑点和价格影响。最佳做法是审查报价，如有必要进行比较，并在确认之前检查每个参数。

**准备好试用了吗？** [下载 Lumina Wallet](/zh/download)，在每一步都掌握交易信息，并完成您的首次兑换。`
  },
  "comment-eviter-arnaques-crypto": {
    title: "2026年如何避免加密货币诈骗：终极指南",
    meta: "了解2026年最常见的加密货币诈骗（钓鱼、Rug Pull、虚假空投）以及如何避免它们来保护您的资产。保护钱包的完整指南。",
    body: `加密货币世界令人兴奋，但也吸引了许多恶意行为者。2025年，加密诈骗已达到前所未有的复杂程度，给投资者造成了数十亿美元的损失 [1]。了解这些威胁是保护您数字资产的第一步。

## 2026年最常见的加密诈骗类型

### 1. 钓鱼攻击

钓鱼仍然是最常用的方法。诈骗者创建完美模仿合法平台（交易所、钱包、DeFi项目）的虚假网站，诱导您输入助记词（seed phrase）或连接钱包。

> **具体案例**：您收到一封看似来自MetaMask或交易平台的电子邮件，要求您点击链接验证账户。该链接会将您重定向到一个克隆网站，记录您的机密信息。

**如何避免**：
- 不要点击未经请求的邮件或私信中的链接。
- 始终验证网站URL。
- **永远不要**在网站上输入您的助记词。

### 2. Rug Pull（跑路）

当开发团队发行新代币、吸引投资者推高价格，然后突然撤走项目所有流动性时，就会发生"Rug Pull"。

**如何避免**：
- **研究团队**：匿名团队是重大警告信号。
- **检查流动性**：是否已锁定？
- **分析代币分配**：少数地址持有大量供应量 = 高风险。

### 3. 虚假空投和赠品

诈骗者承诺免费代币，换取"交易费"或要求连接钱包到恶意网站。

**如何避免**：
- 合法空投**绝不会**要求您发送资金或提供助记词。
- 警惕不切实际的收益承诺。
- 始终在项目官方渠道上核实信息。

### 4. 智能合约授权诈骗（Approve/Permit）

您签署一笔交易，授权恶意智能合约花费您钱包中的代币。

## Lumina Wallet 如何保护您

| 安全功能 | Lumina如何保护您 |
|---|---|
| **实时反诈骗扫描器** | 在每笔交易前，分析接收地址和智能合约以检测已知威胁。 |
| **交易模拟** | 在您签名**之前**，准确显示交易将做什么。 |
| **自托管（Non-Custodial）** | 您的私钥永远不会离开您的设备。 |

## 结论

使用安全钱包如 **Lumina Wallet**，您将增加一层重要的技术保护。

**准备好保护您的加密资产了吗？** [立即下载Lumina Wallet](#)，安心交易。

---

### 参考资料

[1] Chainalysis. (2026). *2026 Crypto Crime Report: Scams*. [https://www.chainalysis.com/blog/crypto-scams-2026/](https://www.chainalysis.com/blog/crypto-scams-2026/)`
  },
  "securiser-wallet-crypto": {
    title: "如何保护您的加密钱包：10个关键步骤",
    meta: "学习如何通过我们的完整指南保护您的加密钱包。保护助记词，使用非托管钱包并启用2FA。",
    body: `您加密货币的安全不仅取决于您使用的平台，还取决于您自己的习惯。

## 1. 选择非托管钱包（自托管）

**非托管**钱包如 **Lumina Wallet** 意味着只有您持有私钥。

> **"Not your keys, not your coins"** 是必记的格言。

## 2. 保护您的助记词（Seed Phrase）

- **写在纸上**：不要存储在联网设备上。
- **制作多个副本**：存放在不同的安全位置。
- **绝对不要分享**。

## 3. 使用强大且唯一的密码

## 4. 启用双重认证（2FA）

## 5. 警惕公共Wi-Fi

## 6. 分散资金：「热钱包」和「冷钱包」

| 钱包类型 | 用途 | 示例 |
|---|---|---|
| **热钱包** | 日常交易、兑换。 | **Lumina Wallet**（移动/网页） |
| **冷钱包** | 长期存储。 | 硬件钱包（Ledger、Trezor） |

## 7. 保持应用更新

## 8. 对dApp和新项目保持怀疑

**Lumina Wallet** 通过交易模拟提供帮助。

## 9. 撤销授权

使用 [Revoke.cash](https://revoke.cash/) 检查和撤销不需要的授权。

## 10. 使用具有内置安全功能的钱包

**Lumina Wallet**：反诈骗扫描器、交易模拟、原生多链支持。

## 结论

遵循这10个步骤，配合 **Lumina Wallet**，您将显著降低风险。

**准备好升级安全等级了吗？** [下载Lumina Wallet](#)，掌控全局。`
  },
"wallet-non-custodial-guide": {
    title: "什么是非托管钱包？完整指南",
    meta: "了解托管钱包和非托管（自托管）钱包的区别。了解为什么像Lumina Wallet这样的非托管钱包对您的加密货币安全至关重要。",
    body: `如果您是加密货币新手，可能听过"托管"和"非托管"这两个术语。

## 托管 vs. 非托管：关键区别

| 钱包类型 | 谁控制私钥？ | 示例 |
|---|---|---|
| **托管** | 平台（第三方） | 交易所（Binance、Coinbase） |
| **非托管（自托管）** | **您** | **Lumina Wallet**、MetaMask、Ledger |

### 托管钱包：以控制权换取简单性

如果平台被黑客攻击，您可能失去一切。**"Not your keys, not your coins."**

### 非托管钱包：完全控制和真正的所有权

**Lumina Wallet** 通过12或24个词的**助记词**给予您完全控制。

**优势：**
- **完全控制**：您就是自己的银行。
- **最高安全性**：无平台被黑风险。
- **隐私**：无需KYC。

## Lumina Wallet：两全其美

- **100%非托管**
- **直觉化界面**
- **多链**：在一个应用中管理所有资产。

**准备好成为自己的银行了吗？** [下载Lumina Wallet](#)，体验真正的加密资产所有权。`
  },
  "comparatif-wallets-crypto": {
    title: "2026年最佳加密钱包对比",
    meta: "2026年最好的加密钱包是哪个？Lumina Wallet、MetaMask、Trust Wallet和硬件钱包（Ledger、Trezor）的完整对比。",
    body: `选择合适的加密钱包至关重要。本对比分析2026年最热门的钱包。

## 对比：Lumina vs. MetaMask vs. Trust Wallet vs. Ledger

| 功能 | Lumina Wallet | MetaMask | Trust Wallet | Ledger |
| --- | --- | --- | --- | --- |
| **类型** | 非托管 | 非托管 | 非托管 | 非托管（冷存储） |
| **安全性** | 非常高（反诈骗扫描器） | 高 | 高 | 最高 |
| **多链支持** | BTC, ETH, SOL, XRP +10 | EVM 网络、Solana 和 Bitcoin | 良好 | 良好 |
| **易用性** | 为新手设计 | 对新手而言较技术化 | 简单 | 中等 |
| **内置兑换** | 是（Lumina 不额外收取服务费；可能产生合作方定价、网络费、价差、滑点和价格影响） | 是（0.875%） | 是 | 是（有手续费） |
| **NFT画廊** | 是（多链） | 是（EVM） | 是 | 是 |

## 结论

- **日常管理**：**Lumina Wallet**
- **长期存储**：**硬件钱包**
- **以太坊DeFi专家**：**MetaMask**

**准备好选择了吗？** [下载Lumina Wallet](#)，开启全新加密体验。`
  },
  "guide-debutant-crypto": {
    title: "新手指南：2026年如何开始加密投资",
    meta: "想开始接触加密货币但不知从何开始？这份简单指南为您解释一切：购买首批加密货币、选择安全钱包和进行首次交易。",
    body: `加密货币世界初看可能令人生畏。但入门比想象的简单。

## 第1步：理解基本概念

- **区块链**：一种公开的、去中心化的安全数字账本。
- **加密货币**：使用密码学保护交易的数字资产。最知名的：Bitcoin (BTC) 和 Ethereum (ETH)。
- **钱包**：用于存储、发送和接收加密货币的应用程序。

## 第2步：购买首批加密货币

通过**中心化交易平台（CEX）**如Coinbase、Binance或Kraken。

1. **创建账户**。
2. **验证身份**（KYC程序）。
3. **存入资金**。
4. **购买您选择的加密货币**。

## 第3步：在非托管钱包中保护您的加密资产

**必须将**加密资产转移到您完全控制的钱包中，如 **Lumina Wallet**。

1. **下载Lumina Wallet**。
2. **创建新钱包**。应用将生成一个**助记词**。
3. **将助记词写在纸上**，安全保存。
4. **将加密资产转入**您的新Lumina Wallet地址。

## 第4步：首次交易

- **发送和接收**：通过钱包地址发送加密货币。
- **兑换**：在Lumina Wallet中直接兑换，Lumina 不额外收取服务费（仍需支付网络费并适用合作方条件）。
- **与dApp交互**：通过WalletConnect连接数千种去中心化应用。

## 新手建议

- **只投资您能承受损失的金额**。
- **自己做研究（DYOR）**。
- **保持耐心**。
- **安全第一**。

**准备好迈出第一步了吗？** [下载Lumina Wallet](#)，加入去中心化金融革命。`
  },
  "seed-phrase-guide": {
    title: "什么是助记词（Seed Phrase）？",
    meta: "您的助记词（seed phrase）是加密钱包的钥匙。了解它是什么、如何工作以及安全存储的最佳实践。",
    body: `在非托管钱包世界中，**助记词**是最基本的安全概念。

## 什么是助记词？

创建非托管加密钱包（如 **Lumina Wallet**）时生成的**12至24个词**的列表。

> **示例**：\`witch collapse practice feed shame open despair creator tenant camp strike\`

## 它如何工作？

基于**BIP-39**密码学标准：

1. 钱包生成随机数序列。
2. 转换为来自2048词标准化词典的词列表。
3. 导出**主私钥**。
4. 从主私钥生成每种加密货币的**独立私钥**。

## 为什么如此重要？

- **设备丢失时**：在新设备上安装Lumina Wallet，输入助记词，即可恢复访问。
- **如果他人获得助记词**：可以窃取您的全部钱包。

> **黄金法则**：像对待金条一样对待您的助记词。

## 安全存储方法

### 应该做的
- **写在纸上**。
- **制作多个副本**存放在不同安全位置。
- **使用耐久材料**：金属板雕刻。

### 不应该做的
- **不要数字存储**。
- **不要存储在云端**。
- **绝不与任何人分享**。

**准备好掌控一切了吗？** [下载Lumina Wallet](#)，体验自托管的力量。`
  },
  "arnaques-smart-contracts": {
    title: "智能合约：如何避免授权诈骗（Approve / Permit）",
    meta: "智能合约诈骗（Approve、Permit）越来越常见。了解黑客如何清空您的钱包以及Lumina Wallet的扫描器如何保护您。",
    body: `你以为从不分享助记词就安全了吗？再想想。新一代诈骗直接针对**智能合约**交互。

## 理解代币授权（Approve）

**什么是授权？** 您给予智能合约代您花费一定数量代币的许可。

### 无限授权的危险

许多dApp请求**无限授权**——您永久授权智能合约花费无限数量的代币。

## "Permit"诈骗和链下签名

1. 恶意网站请求签署消息（**没有gas费用**）。
2. 消息包含\`Permit\`授权。
3. 黑客利用签名清空您的代币。

> **陷阱**：没有gas费用 = 看似无害。这是错误的。

## Lumina Wallet如何革新交易安全

| 普通钱包 | Lumina Wallet |
| --- | --- |
| 无法理解的十六进制数据 | **警告：您即将授权花费您所有的USDC。** |
| "签署消息" | **注意：此消息授权转移您的NFT。** |

## 最佳实践

1. **使用带交易模拟的钱包**，如 **Lumina Wallet**。
2. **对过于美好的机会保持极度警惕**。
3. **使用一次性钱包**测试未知dApp。
4. **定期撤销授权**，使用 [Revoke.cash](https://revoke.cash/)。

**不要再盲目签署。** [下载Lumina Wallet](#)，了解真正的交易安全。`
  },
  "arnaque-smart-contract-trust-wallet-vs-lumina": {
    title: "智能合约诈骗：为什么您的钱包形同虚设（以及Lumina如何保护您）",
    meta: "通过震撼对比了解无限智能合约授权诈骗如何清空您的钱包。看看为什么Lumina Wallet提供了其他钱包没有的保护。",
    body: `> **背景：** 2026年3月13日，[Le Parisien报道](https://www.leparisien.fr/faits-divers/arnaque-aux-cryptos-a-paris-les-escrocs-presumes-auraient-depouille-leurs-victimes-de-11-millions-deuros-13-03-2026-D53QN2HAUVFHZGX6YJBD6LKLLA.php)一个诈骗网络窃取了**1100万欧元的加密货币**。手段：欺诈网站和操纵的智能合约授权。

---

这个诈骗最大的帮凶？**您自己的钱包。** 大多数钱包显示的警告太弱，普通用户根本无法理解危险。

## 测试：真实的诈骗网站

我们测试了真实的诈骗网站：**bitcoin-suisse-verif.com**。

## 1. Trust Wallet的反应：看不见的危险

Trust Wallet显示简单的确认发送0 ETH。没有任何警告。

## 2. Lumina Wallet的反应：主动防护盾

![Lumina Wallet安全警告 - 检测到危险](https://customer-assets.emergentagent.com/job_92eb487e-5db1-496a-be31-c7d8444bed8d/artifacts/9ltapzuw_screenshot_danger.png)

- **清晰可见的警告**："危险 - 无限访问"鲜红显示。
- **通俗语言解释**。
- **主动劝阻**：默认按钮是"拒绝"。

## 直接对比

| | Trust Wallet | Lumina Wallet |
|---|---|---|
| **视觉警告** | 无 | 鲜红色危险警告 |
| **风险解释** | 无 | 清晰直接 |
| **授权类型** | 未提及 | "对所有代币的无限访问" |
| **合约已验证？** | 未提及 | "未验证合约"警告 |
| **默认操作** | 批准 | 拒绝 |

> **"同样的诈骗，两个钱包，两种反应。一个让您失望，另一个保护您。"**

**您的安全只需一键。** [立即下载Lumina Wallet](#)，体验真正为您服务的钱包。`
  }
,
  "empoisonnement-adresse-arnaque-crypto": {
    title: "地址投毒 (Address Poisoning)：一种造成数百万美元损失的新型加密货币骗局",
    meta: "了解地址投毒 (address poisoning) 的运作方式，为什么一个简单的复制粘贴操作可能会让你损失数百万，以及 Lumina Wallet 如何保护你。",
    body: `## 复制粘贴的隐形威胁

在瞬息万变的加密货币世界中，每笔交易都至关重要，警惕性必不可少。一种新的、阴险的威胁正在蔓延：**地址投毒**。一个简单的复制粘贴，日常生活中一个无意的举动，现在可能会让您损失数百万。网络犯罪分子这种复杂的策略甚至针对最精明的用户，将便利性变成毁灭性的陷阱。随着加密诈骗持续增多且专业化，了解这种攻击的工作原理对于更好地防范至关重要。

## 什么是地址投毒？

地址投毒是一种诈骗形式，攻击者通过**操纵您的交易历史记录**来欺骗您。目的是让您将资金发送到一个恶意地址，该地址与您之前互动过的合法地址惊人地相似。网络犯罪分子利用了人类的一个基本弱点：即只检查一个长而复杂的地址的开头和结尾字符的习惯。

**具体示例：** 假设您经常向地址 \\\`0x123...abc\\\` 发送资金。攻击者会生成一个地址 \\\`0x123...abC\\\`（只有一个微小差异，通常是一个字符），并将其注入到您的交易历史记录中。当您想向常用联系人发送资金时，您可能会无意中复制攻击者的地址，而非正确的地址。

## 工作原理：诈骗机制

这个过程看似简单，实则具有欺骗性：

### 1. 注入
攻击者监控区块链以识别活跃的钱包。然后，他们从自己控制的地址向您的钱包发送极少量加密货币（通常是 0 ETH 或微不足道的代币碎片）。这个地址经过特殊设计，旨在与您之前进行过交易的地址相似。

### 2. 历史记录
这笔微小但恶意的交易会出现在您的钱包历史记录中。它通常位于您合法交易的附近，增加了您注意到它的可能性。

### 3. 复制粘贴
当您希望向常用联系人发起新交易时，您可能会因为习惯或疏忽，从您的历史记录中复制攻击者的地址，而非正确的地址。

### 4. 损失
一旦资金发送到攻击者的地址，它们将**不可逆转地丢失**。区块链的去中心化特性使得交易无法撤销或资金无法追回。

## 后果：不可逆转的损失

地址投毒的危险性在于其隐蔽性和区块链交易的终局性。一旦您确认发送到攻击者的地址，就没有任何追索权。资金被转移并消失在恶意钱包的迷宫中，通常很快被清洗，使得任何追回几乎不可能。

## Lumina Wallet 如何保护您：地址安全审计扫描器

面对这一日益增长的威胁，**Lumina Wallet** 定位为您的第一道防线。我们的地址安全审计扫描器旨在检测这些隐形陷阱，避免它们给您造成巨大损失。其工作原理如下：

- **实时验证**：您与之交互的每个地址都会经过严格的即时验证。
- **恶意地址检测**：Lumina 不仅仅验证技术有效性 (EIP-55)。它还会与实时威胁情报数据库（通过 GoPlus Security 等合作伙伴）进行信息交叉比对，以识别与黑名单、网络钓鱼或蜜罐相关的已知地址。
- **清晰警报**：在您批准交易之前，Lumina 会为您提供清晰的安全指示：**绿色**（安全）、**黄色**（谨慎）或**红色**（危险/已阻止）。这使您能够做出明智的决定，避免代价高昂的错误。

借助 Lumina Wallet，您将获得主动保护，这种保护超越了简单的私钥管理，保护您免受利用人类弱点的复杂诈骗的侵害。

## 加密用户预防提示

尽管 Lumina Wallet 提供了先进的保护，但一些良好实践仍然至关重要：

- **始终验证完整地址**：花时间检查目标地址的每个字符，而不仅仅是开头和结尾。
- **进行小额测试**：在发送大额资金之前，进行一笔小额测试交易，以确保地址正确无误。
- **使用安全钱包**：优先选择集成先进安全功能（如 Lumina Wallet 的地址扫描器）的钱包。

## 结论：技术赋能下的增强警惕性

地址投毒残酷地提醒我们，加密领域的安全是一场持续的战斗。但有了正确的工具，您并非孤军奋战。**Lumina Wallet** 旨在成为您的盾牌，将尖端技术与直观界面相结合，为您提供安心无忧的体验。自信地畅游加密货币世界，因为 Lumina Wallet 是您抵御现代诈骗的第一道防线。

[在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载 Lumina Wallet](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  }
,
  "permit2-arnaques-signature-crypto": {
    title: "Permit2 和签名骗局：保护您的钱包免受隐形陷阱的侵害",
    meta: "了解 Permit2 签名和无限批准的危险。了解 Lumina 钱包如何解码每个签名，以保护您免受钱包窃取者的侵害。",
    body: `## 交易签名的潜在危险

在 Web3 生态系统中，交易签名是控制的终极行为。这是您同意在区块链上执行某个操作的时刻。然而，随着协议的演进和 **Permit2** 等新功能的出现，网络犯罪分子找到了将这种信任行为变成隐形陷阱的方法。您可能认为自己只是签署了一笔简单的交易，而实际上，您却赋予了他人无限访问您资金的权限。了解签名骗局对于所有加密货币用户来说至关重要。

## Permit2 是什么？它为何有用？

Permit2 是一种创新的智能合约，最初由 **Uniswap** 设计，旨在简化和优化代币授权的管理。传统上，每当您想在 DEX 上交易一种新代币时，您都需要进行单独的授权交易，这既消耗 gas 又耗时。Permit2 允许通过“链下”（off-chain）签名来聚合和管理这些授权，从而使与 DeFi 的交互变得更加流畅和经济。

## Permit2 骗局如何运作？

不幸的是，这种效率的提高也为新型网络钓鱼打开了大门：

### 1. 欺诈性网站或 dApp
攻击者创建模仿流行 DeFi 服务的平台。当用户尝试与这些网站交互时，会被要求签署 Permit2 签名。

### 2. 欺骗性签名
与经典交易不同，Permit2 签名的内容通常以**原始十六进制数据**的形式呈现，这对于普通用户来说是难以理解的。攻击者利用这一点，巧妙地插入了对其自身地址的无限授权请求。

### 3. 毁灭性后果
一旦签名完成，攻击者就获得了转移您代币的权利，**而无需您签署新的交易**。您的钱包可能会瞬间被清空，链上没有任何预警信号。

## 为什么它如此危险：授权的隐形威胁

签名骗局的主要危险在于其**隐形性**。Permit2 签名不会立即在区块链上触发交易。它赋予了攻击者日后可以使用的授权。此外，签名数据的技术复杂性使得不熟悉的用户几乎不可能理解其行为的真正含义。这是对信任和透明度缺失的直接利用。

## Lumina Wallet 的作用：交易与签名解码器

正是此时，**Lumina Wallet** 介入，将黑暗转化为清晰。我们的交易与签名解码器是您抵御隐形陷阱的盾牌：

- **翻译成清晰的语言**：Lumina 能够即时解码 Permit2 签名和 ERC-20 授权的复杂十六进制数据。它以简单易懂的术语，准确地向您展示您即将签署的内容。
- **完全透明**：在每次签名之前，Lumina 都会显示所请求的操作：这是一项有限授权还是无限授权？您正在将访问您资金的权限授予谁？
- **风险评估**：借助我们的颜色编码风险系统（安全、低、中、高、关键），如果某个签名存在潜在危险，您会立即收到警报。

有了 Lumina Wallet，您再也不会盲目签署。通过不打折扣的透明度，您将重新完全掌控您的 Web3 交互。

## 签名安全最佳实践

为了安全导航，请养成以下习惯：

- **仔细阅读**：在阅读并理解所有细节之前，切勿签署任何交易或签名。
- **使用解码工具**：优先选择像 Lumina Wallet 这样能将技术数据翻译成清晰语言的钱包。
- **撤销授权**：养成定期撤销您不再使用的代币授权的习惯。

## 结论：与 Lumina 一起知情签署

Web3 中的安全不应该是一种奢侈，而应该是一种标准。**Lumina Wallet** 致力于为您提供必要的工具，以保护您免受最复杂的威胁。通过在黑暗中带来光明，Lumina 让您能够安全地充分享受 DeFi 和加密货币。自信签署，与 Lumina 一起签署。

[在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载 Lumina Wallet](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "faux-wallets-crypto-clones": {
    title: "假冒加密钱包：如何识别掏空您账户的克隆应用",
    meta: "骗子分发完美克隆的钱包应用来窃取您的 12 或 24 个助记词。了解警示信号，保护您的 Web3 钱包。",
    body: `## 假钱包的解剖

骗子投入大量资源来创建最流行钱包的完美复制品。这些克隆应用复制了合法应用的徽标、颜色、字体和精确的用户界面。肉眼几乎无法区分伪造品和正版。

陷阱通常分三步收拢：

### 1. 欺诈性分发
假钱包通过搜索引擎的误导性广告、社交网络（X、Telegram、Discord）的私信，甚至通过暂时绕过官方应用商店过滤器进行分发。

### 2. 更新或错误的假象
安装后，克隆应用会模拟技术问题：虚假的连接错误、冻结的余额或所谓的"强制安全更新"。

### 3. 提取助记词
为"解决"这个假问题，应用要求您输入 12 或 24 个助记词。您一确认，这些词就以明文形式传输到攻击者的服务器，瞬间清空您所有相关区块链上的账户。

## 绝不能忽视的警示信号

- **索要助记词** — 合法的钱包、技术支持或网站**绝不会**要求您输入助记词来解决问题。您的 12 或 24 个词只用于一个目的：在新设备上恢复账户。
- **无端弹窗** — 如果在浏览与加密无关的网站时突然弹出登录窗口，请立即关闭。
- **下载来源** — 只从官方网站下载钱包和扩展。切勿点击邮件或私信中的链接。检查 URL 是否有细微拼写错误（如"rn"代替"m"）。

## 设备安全与链上安全

像 **Lumina Wallet** 这样的非托管钱包会分析交易、解码智能合约，并在您即将向危险地址发送资金时提醒您。它通过实时威胁情报交叉核对数据，阻止链上钓鱼。

然而，**如果设备被恶意软件入侵，或您主动在假应用中输入助记词，任何钱包都无法保护您**。

## 您的安全清单

- 只从 [luminawallet.org](https://luminawallet.org) 或官方商店下载 Lumina Wallet。
- 核实发行方：Lumina Wallet 为 **HÉDONISME SARL**。
- 保持操作系统和应用更新。
- 除非在可信设备上主动恢复账户，否则绝不输入助记词。

## 结论

Web3 安全需要全面的数字卫生。Lumina 保护您的链上交互；由您来保护运行环境。

[在 Google Play 下载](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "faux-support-arnaques-recuperation-crypto": {
    title: "假客服与恢复骗局：加密受害者遭受的双重打击",
    meta: "遭黑客攻击后，第二波骗子承诺付费即可找回您的资金。学会识别虚假恢复服务和假客服。",
    body: `> 被盗后想了解具体该怎么做？请阅读[加密资产被盗：最初 24 小时内该做什么](/zh/blog/crypto-volees-que-faire)。

## 双重打击

因粗心、黑客或诈骗损失加密货币是一种创伤性经历。在随之而来的恐慌中，受害者拼命寻找解决方案。正是在这个最脆弱的时刻，第二类骗子发起攻击：**虚假恢复服务和假冒技术支持**。

这些骗局通常被称为"预付费欺诈"，基于残酷的心理操纵。

> **定义——恢复骗局：** 针对已经受害者的第二次欺诈，承诺以付款、敏感数据或设备访问权限为交换找回其资金。

## 恢复骗局

骗子保留受害者名单，并主动监控论坛、社交网络和评论区。手法如下：

1. **天赐的联系** — 一位所谓的网络安全专家、"道德黑客"或假冒金融当局的代理人联系您，声称已追踪到您的资金。
2. **虚假证明** — 他向您展示一个装满资金的钱包截图或一个显示与您损失金额相符余额的网站。两者都由他控制。
3. **费用陷阱** — 您的资金"已准备好转账"，但您必须先支付费用："解锁税"、"网络费用"或"法律佣金"。
4. **恶性循环** — 如果您付款，他们会编造新借口要求更多付款。永远不会有资金归还。

## 假技术支持

一种非常常见的变体是冒充知名钱包或交易所的技术支持团队。这些假客服通常在 X、Telegram 或 Discord 上活动。您一在公开场合询问问题，他们就会用官方标志和专业口吻私信您。

他们的目标始终如一：说服您分享助记词或点击钓鱼链接。

## 揭示骗局的信号

- **加密交易不可逆。** 没有任何公司、黑客或当局可以"取消"已确认的交易。
- **客服从不主动联系您。** 合法团队从不通过私信、短信或电话主动联系用户。
- **助记词是禁忌。** 没有任何技术支持需要它。
- **当局不索要加密货币。** 警方或监管机构绝不会主动联系您归还资金。

## 欺骗性承诺表

| 收到的承诺 | 骗子的真实目的 | 安全回应 |
|---|---|---|
| "我们找到了您的钱包。" | 制造紧迫希望，然后索要费用。 | 不付款；通过官方渠道核实。 |
| "支付解锁税。" | 首笔付款后还会有更多。 | 中断联系；保留消息作为证据。 |
| "安装此软件，我才能帮您。" | 控制您的设备或窃取秘密。 | 拒绝任何远程访问。 |
| "给我 12/24 个词以便重新同步。" | 完全永久控制您的账户。 | 绝不分享助记词。 |

## 如何应对

1. **切断所有通讯**，不要屈服于威胁或虚假承诺。
2. **保护剩余的资产** — 在干净的设备上将资产迁移到新钱包；撤销可疑的智能合约授权。
3. **保留证据** — URL、截图、加密地址和交易哈希。
4. **报告并投诉** 相关主管当局。

## 透明为先

在 Lumina Wallet，我们构建工具来防止您向骗子发送资金或批准危险合约。我们的扫描器在您签名之前分析地址和交易。

但我们对技术的局限性坦诚以告：**如果欺诈交易已在区块链上确认，Lumina 无法撤销**。当心任何声称能撤销的人。

[在 Google Play 下载](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "qr-code-copier-coller-detournement-crypto": {
    title: "二维码和复制粘贴：当目标地址欺骗您时",
    meta: "剪贴板恶意软件、假冒付款二维码、欺诈性贴纸：了解骗子如何劫持您的加密转账，以及 Lumina Wallet 如何保护您。",
    body: `## 代价高昂的日常动作

在加密世界中，地址是长而复杂的字母数字字符串。没有人手动输入。为了转账，我们都依赖两个日常动作：**复制粘贴**和**扫描二维码**。

骗子知道这一点。与其试图破解区块链的密码学，不如瞄准这两个动作，在您启动付款的确切时刻劫持您的资金。

> **定义——目标劫持：** 一种操纵手法，替换或掩盖加密付款实际使用的地址，而用户仍以为自己在向合法收款人发送。

## 剪贴板劫持（Clipboard Hijacking）

剪贴板劫持攻击的可怕之处在于其简单性和隐蔽性。它依赖于在您不知情的情况下安装在设备上的恶意软件。

1. 您复制收款人的合法加密地址。
2. 不断监控剪贴板的恶意软件检测到符合加密地址格式的字符串。
3. 在一瞬间，它在设备内存中将合法地址替换为黑客的地址。
4. 当您将地址粘贴到钱包中时，出现的是黑客的地址。

如果您在没有仔细阅读粘贴地址的情况下确认交易，您的资金就会被送到骗子手中。

## 二维码陷阱

二维码大大简化了移动支付，但它们掩盖了实际信息。二维码只是数据的可视化表示：它可以包含加密地址、付款请求、WalletConnect URI 或钓鱼链接。

常见的二维码欺诈方法：

- **假付款门户** — 二维码将您引导至完美模仿合法平台的网站。
- **电话冒充（FTC 警报）** — 冒充当局或客户服务的骗子让您保持通话，将您引导至加密自动取款机，并要求您扫描他发送的二维码。该代码包含他自己钱包的地址。
- **欺诈贴纸** — 在物理世界中，罪犯有时会将自己的二维码贴在商家合法二维码之上。

## 攻击向量汇总表

| 向量 | 用户看到的 | 实际发生的 | 优先验证 |
|---|---|---|---|
| 被劫持的剪贴板 | 刚从可靠来源复制的地址。 | 恶意软件在粘贴前替换了它。 | 将粘贴后的地址与原始来源比较。 |
| 欺诈付款二维码 | 显示为收款人的代码。 | 包含骗子的地址。 | 通过第二渠道确认地址。 |
| 钓鱼二维码 | 快速访问服务。 | 打开欺骗性域名。 | 在继续之前阅读域名和操作。 |
| 覆盖贴纸 | 物理位置显示的二维码。 | 原始代码被覆盖。 | 检查表面；向商家确认。 |

## 保护转账的反射动作

- **粘贴后始终验证**：将前几个和最后几个字符与原始来源进行比较。
- **警惕意外的二维码**，无论来自电子邮件、短信还是社交媒体。
- **保护您的设备**，保持操作系统更新并使用可靠的杀毒软件。
- **金额大时先做测试转账**（尽管这会使网络费用翻倍）。
- **重读确认屏幕**：网络、资产、金额和最终地址。

## Lumina 的方法：发送前审计

人为错误不可避免，因此现代钱包必须充当安全网。Lumina 没有使用可能将您重定向到恶意站点的通用扫描器，而是分离用途。发送屏幕上的扫描器只读取加密地址。如果检测到网络链接或可疑命令，会立即阻止操作。

无论您是粘贴还是扫描，Lumina 不仅接受地址，还会执行**即时安全审计**：

- 地址格式验证。
- 与威胁情报数据库（如 GoPlus Security）实时交叉核对。
- 在您确认交易之前发出清晰警报。

您保持完全控制，同时获得必要的信息来在为时已晚之前发现劫持。

[在 Google Play 下载](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "how-to-secure-crypto-wallet": {
    title: "如何在 2026 年保护你的加密钱包:完整防诈骗指南",
    meta: "了解如何通过安全专家使用的 10 条核心规则保护你的加密钱包。保护助记词、识别假钱包、拦截恶意签名,让你的 Bitcoin、Ethereum、Solana 和 XRP 在 2026 年安然无恙。",
    body: `如果你持有加密货币,有一个问题比任何价格走势图都更重要:**如何保护你的加密钱包**,让攻击者永远无法下手。2026 年,加密用户被盗金额超过 38 亿美元,而其中绝大部分来自**钱包层面的攻击**,而不是交易所被黑 [1]。这意味着,对你的资产安全负最大责任的人,就是你自己。

好消息是:保护加密钱包并不复杂,只需要养成一系列简单而有意识的习惯。本指南将为你提供注重安全的用户用来保护 Bitcoin、Ethereum、Solana、XRP 及其他数字资产的 10 步方法,并向你展示像 **Lumina Wallet** 这样专为安全而设计的应用如何替你完成大部分繁重的工作。

## 为什么"如何保护我的加密钱包"其实问错了问题

大多数指南回答的是*"哪个钱包最好?"*。但真正的问题是:**我该如何保护自己已经在用的钱包?** 因为在加密世界里,钱包的安全程度取决于你最薄弱的那个习惯。如果你把助记词输入了钓鱼网站,再好的硬件钱包也救不了你。如果你签署了恶意合约,非托管钱包也保护不了你。

因此,本指南按重要性的先后顺序,聚焦于**习惯 + 工具**。

## 保护加密钱包的 10 条规则

### 1. 选择非托管钱包——没有例外

**如何保护加密钱包**的第一条规则:绝不要让别人替你保管私钥。

- ❌ **托管钱包**(大多数交易所和部分应用):平台持有你的私钥。如果平台被黑、冻结账户或破产,你的加密资产就没了。
- ✅ **非托管钱包**(如 Lumina Wallet、MetaMask、Trust Wallet):私钥由你自己掌握,你和你的资金之间没有任何中间人。

请牢记这句口诀:**"Not your keys, not your coins"(私钥不在你手,资产就不属于你)。**

### 2. 像保护毕生积蓄一样保护你的助记词(因为它就是)

你的 12 或 24 个单词的助记词就是主密钥。任何拿到它的人都能在 30 秒内、在世界上任何地方清空你的钱包。

**正确的保管方式:**

- 📝 **写在纸上**(或刻在金属板上),绝不要以电子形式保存。
- 🚫 **绝不要拍照**。绝不要存入 iCloud、Google Drive、备忘录,或任何联网的密码管理器。
- 🔒 **制作 2-3 份实体备份**,分别存放在不同的安全地点(家用保险箱、可信赖的家人、银行保管箱)。
- 🗣️ **绝不要告诉任何人**。客服不行,"钱包开发人员"不行,"税务局人员"也不行。任何正规渠道都不会向你索要助记词。

> ⚠️ **黄金法则**:只要有人、网站或应用索要你的助记词,那 100% 是骗局。没有任何例外。

### 3. 使用强且唯一的钱包密码

钱包密码会在你的设备本地加密你的私钥。请做到:

- 至少 **14 个字符**
- 混合使用大写字母、小写字母、数字和符号
- **与你使用的其他任何密码都不相同**
- 存放在密码管理器中(Bitwarden、1Password、KeePass)

### 4. 启用生物识别验证 + PIN 码

现代加密钱包支持 Face ID、指纹识别和 6 位 PIN 码。请**三层全部启用**。即使有人偷走你的手机,没有你的生物特征,他们也打不开你的钱包。

### 5. 当心假冒钱包应用

骗子会在 Google Play 和 App Store 上架**克隆应用**,名称类似*"Lumina Wallet Pro"*、*"Lumina — Free Airdrop"*,或使用山寨 logo。它们看起来一模一样,但你一输入助记词就会被盗取。

**如何避开假钱包:**
- ✅ 只从项目官网上的**官方链接**下载(例如 https://luminawallet.org)
- ✅ 核对**开发者名称**是否一致(Lumina Wallet 的开发者为 HEDONISME SARL,应用名为 *Lumina Wallet*)
- ✅ 查看下载量和评价数量——克隆应用的下载量通常不足 100
- ✅ 阅读我们的完整指南:[假钱包克隆应用](/en/blog/fake-crypto-wallet-clones)

### 6. 转账前务必核对收款地址

地址投毒攻击正在激增:骗子会从一个**看起来很像**你常用地址的地址向你发送一笔极小额交易(前 4 位和后 4 位字符相同,中间不同)。你从历史记录中复制粘贴地址,结果把资金直接转给了攻击者。

**如何避免:**
- ✅ 始终核对**完整地址**,而不仅仅是开头和结尾
- ✅ 使用带有**地址簿**的钱包来保存可信联系人(Lumina 内置了地址簿)
- ✅ 大额转账前,先发送一笔**小额测试交易**

### 7. 绝不签署你不理解的交易

2026 年技术含量最高的骗局是**恶意签名**:你点击了看似登录按钮的"签名",实际上却授权了对你的 USDC/ETH 的无限额度支配权。攻击者第二天就会清空你的钱包。

**签名前的保护清单:**
- 🔍 阅读交易数据——是什么代币?多少数量?哪个合约?
- 🚨 **"无限授权"**或 **"setApprovalForAll"** = 危险信号
- 🚨 **刚打开的网站就要求签名** = 危险信号
- 🚨 钱包提示*"此交易可能存在危险"* = 立即停止

带有**交易扫描器**的钱包(如 Lumina Wallet)可以在你签名之前拦截这些攻击。

### 8. 保持钱包应用和手机系统为最新版本

每次钱包更新都包含针对新发现漏洞的**安全补丁**,手机操作系统同样如此。过时的应用就是一个已知的攻击面。

- 📱 在 Google Play 和 App Store 上启用**自动更新**
- 🔐 在任何安全更新发布后的一周内更新手机系统

### 9. 绝不要将钱包连接到未知网站

DApp 功能强大,但把钱包连接到诈骗网站,一次签名就可能让你损失殆尽。

**规则:**
- 只连接**你自己输入的网址**或来自官方社交渠道的网址
- 绝不要通过 Discord/Telegram 私信中的链接进行连接
- 使用完 DApp 后,到 [revoke.cash](https://revoke.cash) **撤销授权**
- 将可信的 DApp 加入书签,不要再通过 Google 搜索(Google 广告中充斥着诈骗克隆站)

### 10. 使用内置防诈骗保护的钱包

你是人,会疲惫,也会点得太快。这正是为什么最后一道防线应该是一个能**替你识别骗局**的钱包——在你犯下代价高昂的错误之前就拦住你。

## Lumina Wallet 如何自动保护你的加密资产

Lumina Wallet 专为消除加密领域最大的单点故障而打造:**压力下的人为失误**。以下是它在每一步如何保护你:

| 威胁 | Lumina 如何拦截 |
|---|---|
| **钓鱼地址** | 实时扫描器会将每个收款地址与包含 500,000+ 已知诈骗地址的实时黑名单进行比对。一旦匹配,立即红色警报。 |
| **恶意智能合约** | 在你签名之前,Lumina 会模拟该交易,并*准确*显示哪些代币将离开你的钱包。如果检测到无限授权或资产清空模式,你会收到严重警告。 |
| **地址投毒** | Lumina 会在你发送之前,自动标记与你历史记录相似的地址——哪怕只差 1 个字符。 |
| **虚假 permit / 签名骗局** | ERC-20 Permit 和 Permit2 签名会被解码,并用通俗易懂的语言解释。告别盲签。 |
| **天生非托管** | 你的私钥通过 AES-256 + Secure Enclave 加密存储在你的设备上。Lumina 服务器永远无法看到。执法机构、黑客或公司破产也无法触及。 |
| **生物识别 + PIN + 密码** | 三层锁定,均可按你的舒适程度自由配置。 |

## 硬件钱包呢?

硬件钱包(Ledger、Trezor)能为**长期持仓**(你不会每周动用的 >$10k 资产)增加一层强有力的保护。但它们并不能取代上述 10 条规则,只是对其补充。即使使用 Ledger,你批准的恶意签名同样会让资金被清空。

对于日常使用(兑换、转账、DeFi),**带交易扫描器的安全移动钱包**往往比"裸"硬件钱包*更安全*,因为它能拦截硬件钱包无法阻止的人为失误类攻击。

## 破坏钱包安全的常见错误

即使是了解规则的用户也会犯这些错误。请务必避免:

- ❌ **"只是为了备份"而截图助记词**——iCloud/Google Photos 会把它同步到云端
- ❌ 钱包和邮箱**使用相同的密码**
- ❌ **点击 Google 广告**下载钱包应用或访问 DApp(诈骗广告很常见)
- ❌ **"因为更方便"而长期把加密资产放在交易所**
- ❌ **因为着急而忽略安全警告**
- ❌ 用主钱包连接陌生人的"空投"进行测试

## 快速安全清单(请收藏)

在你再向加密货币投入一分钱之前,请确认你已完成以下全部 10 项:

- [ ] 我使用非托管钱包(私钥由我自己掌握)
- [ ] 我的助记词写在纸上,并存放在 2 个以上的实体地点
- [ ] 我的助记词从未接触过互联网
- [ ] 我的钱包密码至少 14 个字符且唯一
- [ ] 已启用生物识别 + PIN
- [ ] 我只从官方网站下载钱包
- [ ] 我始终核对完整的收款地址
- [ ] 我从不签署自己不理解的交易
- [ ] 我的钱包和手机系统均为最新版本
- [ ] 我只连接我明确信任的 DApp

## 结语:安全是一种习惯,而非一次性设置

钱包安全无法外包。但你可以把**良好习惯**与**在你疏忽时保护你的工具**结合起来,让它变得轻松十倍。这正是 Lumina Wallet 所做的——一款非托管多链钱包,内置防诈骗扫描器、地址验证和交易模拟功能。

每一笔交易都会被检查,每一个签名都会被解码,每一项风险都会在你确认之前用通俗的语言解释清楚。

**准备好以正确的方式保护你的加密钱包了吗?**

[在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)

---

### 参考资料

[1] Chainalysis. (2026). *2026 Crypto Crime Report: Wallet-level attacks*. [https://www.chainalysis.com/blog/crypto-scams-2026/](https://www.chainalysis.com/blog/crypto-scams-2026/)`
  },
  "what-is-non-custodial-wallet": {
    title: "什么是非托管钱包?2026 年新手完整指南",
    meta: "非托管钱包让你真正掌握自己的加密货币私钥——无需银行、无需交易所、没有中间人。了解非托管的含义、它与托管钱包的区别,并通过 Lumina Wallet、MetaMask 和 Trust Wallet 等真实案例加深理解。",
    body: `**非托管钱包**是一种加密货币钱包,控制资金的**私钥只掌握在你自己手中**。没有银行、没有交易所、也没有任何第三方可以访问、冻结或弄丢你的加密资产。如果你刚接触加密货币,这是最需要理解的一个核心概念。本指南将讲解什么是非托管钱包、它的工作原理、真实案例,以及它是否适合你。

## 非托管钱包的含义:30 秒定义

**非托管钱包的定义**:用户完全拥有私钥的加密货币钱包。没有任何第三方保管资金,用户是唯一的保管人。

用大白话来说:**如果你不会因为某家公司决定冻结账户而无法动用自己的钱,那你用的就是非托管钱包。**

### 托管钱包与非托管钱包:快速对比

| 特性 | 托管钱包 | 非托管钱包 |
|---|---|---|
| **谁掌握你的私钥?** | 交易所/公司 | 你自己 |
| **账户会被冻结吗?** | 会,由公司冻结 | 不会——没人能冻结 |
| **公司破产了怎么办?** | 资金可能丢失或被锁定 | 资金 100% 安全 |
| **需要记住助记词吗?** | 不需要(由他们保管) | 需要(由你保管) |
| **政府扣押风险?** | 有(通过传票) | 仅当你被迫交出私钥时 |
| **示例** | Coinbase、Binance、Kraken(其默认钱包) | Lumina Wallet、MetaMask、Ledger、Trust Wallet |

## 非托管钱包是如何工作的?

设置非托管钱包时,会在你的设备上本地完成以下三件事:

1. **生成私钥**——一个巨大的随机数,通过数学方式控制你的加密货币地址。
2. **创建助记词**——12 或 24 个便于人类阅读的单词,可以重新生成私钥。这是你唯一的备份。
3. **派生公开地址**——也就是你分享给他人的"收款地址"。

私钥**永远不会离开你的设备**。当你发送加密货币时,钱包会在本地对交易进行签名,然后只把签名广播到区块链上。没有任何服务器能看到你的私钥。这就是它被称为*非托管*的原因:从头到尾都没有外部托管人。

## 非托管钱包示例:一笔真实的交易

下面是用 Lumina 这类非托管钱包发送 0.1 ETH 时发生的过程:

1. 你输入收款地址和金额
2. 钱包**准备**交易数据(发送方、接收方、金额、gas 费)
3. 钱包使用你的私钥对交易进行**签名**——这一步 100% 在你的手机上完成
4. **已签名的交易**(而非私钥)被发送到以太坊网络
5. 矿工/验证者验证签名在数学上有效
6. 交易在链上确认

在整个过程中,没有任何公司有权撤销、拦截或冻结这笔转账。这就是非托管钱包带来的自由,也是它所附带的责任。

## 为什么选择非托管加密钱包?

### 1. 你就是自己的银行

首要原因:**真正的所有权**。2022 年,FTX 崩盘,数十亿美元的用户资金一夜之间无法取出。而使用非托管钱包的用户完全未受影响。2023 年的 Celsius、Voyager 和 BlockFi 事件也是如此。

> **"不是你的私钥,就不是你的币。"**——这句话只有短短几个字,却帮助无数人避免了加密资产损失。

### 2. 完全的隐私

托管型交易所要求 KYC(身份验证),追踪每一笔交易,并向税务机关和监管机构报告。而非托管钱包只需要你的助记词——不需要邮箱、不需要身份证件、不需要注册。30 秒就能创建一个。

### 3. 没有提现限额,也不会被冻结账户

托管平台会以"可疑活动"、监管审查或系统维护为由冻结账户,有时一冻就是数周。非托管钱包没有这类麻烦:只要有网络,你随时随地都能动用资金,全天候 24/7。

### 4. 接入 DeFi 和 Web3

几乎所有 DeFi 协议(Uniswap、Aave、Lido)、NFT 市场(OpenSea、Magic Eden)和 Web3 应用都需要通过非托管钱包连接。托管钱包无法参与链上应用。

## 非托管钱包开发涉及哪些内容?

对于想了解**非托管钱包开发**的开发者,以下是技术栈:

- 🔐 **密钥生成**:BIP-32(分层确定性密钥)+ BIP-39(助记词)+ BIP-44(多账户派生)
- 🔗 **多链支持**:为每条区块链(Bitcoin、Ethereum、Solana、XRP 等)接入 RPC 服务商或自建节点
- 💾 **本地安全存储**:使用 iOS Secure Enclave / Android Keystore 加密密钥
- ✍️ **交易签名**:Bitcoin/Ethereum 使用 ECDSA,Solana 使用 Ed25519,全部在客户端完成
- 🛡️ **安全防护层**:反诈骗扫描、地址簿、交易模拟

Lumina Wallet 是一款**非托管移动钱包**,具备以上所有功能,并内置**反诈骗扫描器**——因为对新手来说,只有所有权而没有保护,就是一个陷阱。

## 唯一的取舍:你要自己负责

非托管钱包意味着你拥有自己的私钥,但也意味着**你要 100% 为私钥的安全负责**。

- 🔴 **丢失助记词 = 丢失你的加密资产**。没有"忘记密码"按钮,客服也帮不上忙。
- 🔴 **被钓鱼 = 丢失你的加密资产**。已签名的交易无法撤销。
- 🔴 **签署恶意合约 = 丢失你的加密资产**。责任完全在你。

因此,像 Lumina 这样的现代非托管钱包增加了多层保护:
- ✅ 实时诈骗扫描器,拦截已知的钓鱼地址
- ✅ 签名前进行交易模拟
- ✅ 对可疑的"Permit"或"Approve"签名给出清晰警示
- ✅ 地址簿,防止输入错误和复制粘贴攻击

## 2026 年的非托管钱包示例

基于安全性、易用性和多链支持,当前最好的非托管加密钱包:

| 钱包 | 类型 | 支持的链 | 最适合 |
|---|---|---|---|
| **Lumina Wallet** | 移动端 | 10+(BTC、ETH、SOL、XRP、BNB、POL...) | 日常使用 + 防诈骗保护 |
| **MetaMask** | 浏览器 + 移动端 | EVM 链、Solana 和 Bitcoin | DeFi 高级用户 |
| **Trust Wallet** | 移动端 | 70+ | 休闲多链用户 |
| **Ledger** | 硬件 | 100+ | 长期冷存储 |
| **Rabby** | 浏览器 | 以太坊生态 | 带交易模拟的高级 DeFi |

## 非托管移动钱包:安全吗?

安全——前提是你遵循基本的安全实践。出于以下原因,移动端非托管钱包通常**比交易所更安全**:

- 你的私钥由手机的硬件安全模块加密
- 提供生物识别 + PIN 码认证
- 现代钱包(如 Lumina)会扫描每笔交易以防诈骗
- 黑客没有单一的"目标"——1 亿个钱包就是 1 亿个分散的目标

对于你经常使用、金额低于 €10,000 的资产,设计良好的非托管移动钱包能在安全性和易用性之间取得最佳平衡。

## 如何开始使用你的第一个非托管钱包

1. 从官方网站**下载应用**(不要在应用商店搜索——存在仿冒版本)
2. **创建新钱包**——应用会在本地生成你的密钥
3. 把 12 个单词的助记词**抄写在纸上**,存放在安全的地方
4. **设置强密码**并启用生物识别
5. 先**发送一小笔测试金额**,确认一切正常
6. 在存入大额资产之前,请先阅读我们的 **[钱包安全 10 步指南](/en/blog/how-to-secure-crypto-wallet)**

## 非托管钱包常见问题

### 非托管钱包就是热钱包吗?

不完全是。*热钱包*指"连接到互联网"的钱包,*非托管*指"用户掌握私钥"。一个钱包可以既是热钱包又是非托管钱包(Lumina、MetaMask),也可以是非托管的冷钱包(Ledger、Trezor)。

### 如果手机丢了怎么办?

不会有什么问题——只要你还有助记词。在新手机上安装钱包,导入助记词,你的资金就会立刻恢复。

### 我能把托管钱包转换成非托管钱包吗?

无法直接"转换"——但你可以把托管交易所里的资金提到你新创建的非托管钱包中。对于持有大量加密资产的人,这是推荐的做法。

### 非托管钱包需要缴税吗?

非托管钱包不会自动向税务机关申报——但*你*仍然需要为收益纳税。你可以使用 Koinly 或 CoinTracker 等工具,根据钱包的交易记录计算税款。

## 结语:真正拥有你的加密资产

如果你认真对待加密货币,非托管钱包不是可选项,而是基础。每年都有用户因交易所破产、账户冻结或平台被黑而损失巨额财富。而这些都无法触及一个妥善保护的非托管钱包。

**Lumina Wallet 是一款非托管多链钱包**,内置诈骗扫描器、地址簿、交易模拟,并支持 10+ 条区块链——专为既想拥有资产所有权、又需要安全保护的用户打造。

[在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "lumina-wallet-vs-lumina-token": {
    title: "Lumina Wallet 与 Lumina Coin、Pay、Chain 的区别:别把这些项目搞混",
    meta: "分不清 Lumina Wallet 与其他名为\"Lumina\"的加密项目(Lumina Coin、Lumina Pay、Lumina Chain、Lumina Crest AI)?这里为你清晰梳理各项目的区别,避免掉进同名陷阱。",
    body: `你是否在谷歌上搜索过"Lumina crypto",结果发现好几个不同的项目都在使用"Lumina"这个名字?这很正常,而这正是我们想要澄清的混淆。**Lumina Wallet 与你在网上可能遇到的"Lumina Coin"、"Lumina Pay"、"Lumina Chain Base"或"Lumina Crest AI"这些项目没有任何关联。** 下面教你如何清楚地区分它们。

## Lumina Wallet 到底是什么?

**Lumina Wallet** 是一款移动端**非托管**加密钱包应用,由 **HEDONISME SARL** 发布(这是一家法国公司,在敦刻尔克商业与公司注册处 RCS Dunkerque 注册,注册号为 901 439 505)。

### 我们的独特之处:
- 📱 **移动应用**,可在 [Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) 和 [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380) 下载
- 🔐 **非托管**:只有你自己持有私钥
- 🌐 **多链支持**:Bitcoin、Ethereum、Solana、XRP、BNB、Polygon 以及另外 5 条以上的区块链
- 🛡️ **内置防诈骗扫描器**:这是我们最主要的差异化优势
- 🇫🇷 **法国公司**,可在 RCS 商业注册处查证
- 🌍 **唯一官方网站**:[luminawallet.org](https://luminawallet.org)

### Lumina Wallet 不是什么:
- ❌ **不是代币/加密货币**:我们没有原生代币
- ❌ **不是 Layer 1 或 Layer 2 区块链**:我们只是连接现有的区块链
- ❌ **不是自动化投资平台**:我们不提供"保证收益"
- ❌ **不是 B2B 支付服务**:我们是面向个人用户的钱包
- ❌ **不是 AI 项目**:我们是一款加密安全应用

## 其他名为"Lumina"的项目(与我们无关)

以下是你可能遇到的几个名称中带有"Lumina"的主要加密项目:

### 1. Lumina Coin / Lumina Token

多条区块链上存在好几种名为"Lumina"或"LUMI"的 ERC-20 代币。它们是由第三方项目发行的**投机性加密货币**。

⚠️ **警告**:其中一些代币已经发生了 rug pull(团队卷走流动性后消失的骗局)。在**投资之前**,请务必核实团队、合约和流动性。

**与 Lumina Wallet 的关系:无。** 我们不发行任何代币。

### 2. Lumina Pay

一些平台使用"Lumina Pay"这个名称提供加密支付或新型银行服务。同样,**与 Lumina Wallet 没有任何关系**。

### 3. Lumina Chain / Lumina Base

有些项目自称是名为"Lumina Chain"或"Lumina Base"的 Layer 1 区块链或 Rollup。它们与我们的钱包**没有任何关联**,我们并不开发区块链。

### 4. Lumina Crest AI

⚠️ **这个项目需要特别警惕。** 关于 Lumina Crest AI 的多条举报都指向可疑行为(承诺保证收益、锁定提现)。在参与该项目之前,请先在谷歌上搜索"Lumina Crest AI review"。

**Lumina Wallet 与 Lumina Crest AI 绝对没有任何关系。**

## 如何确认你使用的是真正的 Lumina Wallet

为确保你使用的是我们的正版应用而不是仿冒品:

### ✅ 需要进行的检查:

1. **唯一官方网站**:[https://luminawallet.org](https://luminawallet.org)
   - 没有任何其他域名代表 Lumina Wallet
2. **Google Play**:开发者名称 = *Lumina Wallet*,包名 = \`com.luminawallet.app\`
3. **App Store**:应用 ID = \`id6760651380\`,发布者 = *Lumina Wallet*
4. **官方 Twitter/X**:[@getluminawallet](https://x.com/getluminawallet)
5. **我们所有的社交媒体账号**都列在[关于页面](/en/about)

### 🚨 危险信号(诈骗):

- 要求你输入助记词(seed phrase)来"连接"钱包的网站
- 需要预先支付"gas 费"的"Lumina 空投"
- 通过 Telegram 或 Discord 私信联系你的"Lumina 客服"
- 以"Lumina Token"为噱头承诺收益的项目
- 外观与我们相似但网址不同的网站(例如带连字符的 \`lumina-wallet.org\`、\`luminawallet.com\`、\`luminawallets.org\`)

## 为什么会出现这种混淆

"Lumina"这个名字(源自拉丁语 *lumen*,意为光)在加密领域很受欢迎,因为它象征着清晰与透明。结果,**多个互相独立的团队**在没有任何协调的情况下都采用了这个名字。

在 **Lumina Wallet**,我们选择这个名字是为了体现我们的使命:**让加密安全清晰而明亮**。我们的诈骗扫描器会在每笔交易之前,把隐藏的风险暴露在光亮之下。

## 结论

如果你要找的是代币"Lumina Coin"、"Lumina Pay"或任何其他使用这个名称的加密货币/平台:**那不是我们,我们与它们没有任何关联。** 请对这些第三方项目自行研究(DYOR)。

如果你在寻找一款**内置防诈骗保护的非托管多链移动加密钱包**,并且由一家**透明、依法注册的法国公司**发布,那么你来对地方了。

**认识 Lumina Wallet,独一无二:**

[在 Google Play 下载](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "best-non-custodial-crypto-wallet-2026": {
    title: "2026 年最佳非托管加密钱包:全面对比",
    meta: "对比 2026 年最佳非托管加密钱包:Lumina Wallet、MetaMask、Trust Wallet、Rabby、Rainbow、Coinbase Wallet 和 Ledger。功能、安全性、多链支持和防诈骗保护一一对比。",
    body: `在 2026 年选出**最佳非托管加密钱包**比以往任何时候都更难。市面上有几十种选择——手机端、浏览器端、硬件钱包——每一款都声称自己最安全、最易用或功能最丰富。本指南拨开迷雾,基于真实的功能、真实的安全性和真实的用户体验,对 7 款最受欢迎的非托管钱包进行**并排对比**。

## 什么是非托管钱包?(30 秒回顾)

[非托管钱包](/en/blog/what-is-non-custodial-wallet)是指只有**你**才掌握私钥的加密钱包。任何交易所、银行或第三方都无法冻结、没收或丢失你的资金。代价是:你必须对自己的助记词负 100% 的责任。

非托管钱包分为三种类型:
- **手机钱包**(Lumina、Trust Wallet、Rainbow)——最适合日常使用
- **浏览器扩展钱包**(MetaMask、Rabby)——最适合 DeFi 高级用户
- **硬件钱包**(Ledger、Trezor)——最适合长期冷存储

## 2026 年 7 款最佳非托管钱包——并排对比

| 钱包 | 类型 | 支持的链 | 防诈骗扫描器 | 假币过滤 | 最适合 |
|---|---|---|---|---|---|
| **Lumina Wallet** | 手机端 | 10+(BTC、ETH、SOL、XRP、BNB、POL...) | ✅ 内置,实时 | ✅ 按合约白名单 | 希望**安全又不复杂**的日常用户 |
| **MetaMask** | 浏览器 + 手机端 | EVM 链、Solana 和 Bitcoin | ⚠️ 基础警告 | ❌ 显示所有代币 | DeFi 高级用户 |
| **Trust Wallet** | 手机端 | 70+ | ⚠️ 第三方扫描器 | ❌ 显示所有代币 | 休闲多链用户 |
| **Rabby** | 浏览器 | 以太坊生态 | ✅ 交易模拟 | ❌ 显示所有代币 | 需要交易预览的高级 DeFi 用户 |
| **Rainbow** | 手机端 | 以太坊生态 | ⚠️ 基础警告 | ❌ 显示所有代币 | 仅使用以太坊的用户,体验出色 |
| **Coinbase Wallet** | 手机端 + 浏览器 | 20+ | ⚠️ 基础警告 | ❌ 显示所有代币 | Coinbase 交易所用户 |
| **Ledger(搭配 Ledger Live)** | 硬件 | 100+ | ❌ 无扫描器 | ❌ 显示所有代币 | 长期冷存储(>10k€) |

## 深度解析:逐一详解每款钱包

### 🥇 Lumina Wallet——最适合注重安全的日常用户

**亮点:**
- ✅ 非托管,密钥由 iOS Secure Enclave / Android Keystore 加密
- ✅ **三层防诈骗扫描器**(二维码读取、地址审计、交易解码)
- ✅ **假币过滤**——只有官方合约的代币才会出现在你的钱包中
- ✅ 多链支持:Bitcoin、Ethereum、Solana、XRP、BNB Chain、Polygon、Arbitrum、Optimism、Base、Avalanche
- ✅ ERC-20 Permit 和 Permit2 签名以通俗易懂的语言解码
- ✅ 地址簿,防止输入错误和复制粘贴攻击
- ✅ 实时 GoPlus Security 威胁情报
- ✅ **法国公司**(HEDONISME SARL,RCS Dunkerque)——所有权透明

**不足:**
- 暂未开源(已列入计划)
- 目前仅支持手机端(没有浏览器扩展)

**适合人群:**希望**在不成为加密专家的前提下获得最高安全性**的用户,尤其是新手和中级用户。

**评价:** ⭐⭐⭐⭐⭐

### 🥈 MetaMask——DeFi 高级用户的首选

**亮点:**
- ✅ 在 Web3 应用中支持范围最广的钱包
- ✅ 同时提供浏览器扩展和手机应用
- ✅ Snaps 生态系统,扩展性强
- ✅ 开源

**不足:**
- ⚠️ 默认显示所有代币 → 假币会污染你的钱包
- ⚠️ 签名警告较为基础,很容易被忽略
- ⚠️ 母公司 Consensys 因数据收集问题受到过批评

**适合人群:**清楚自己在做什么的 DeFi 高级用户。

**评价:** ⭐⭐⭐⭐

### 🥉 Trust Wallet——链支持最广泛

**亮点:**
- ✅ 支持 70+ 条区块链(同类最广)
- ✅ 内置 DEX 聚合器
- ✅ 隶属于 Binance(团队庞大,资金雄厚)

**不足:**
- ⚠️ 防诈骗保护较为基础(多为被动响应,而非主动防御)
- ⚠️ 显示所有代币 → 存在假币垃圾空投风险
- ⚠️ 曾发生安全事件(2023 年 WalletConnect 漏洞、MPC 缺陷被披露)

**适合人群:**活跃于冷门公链的用户。

**评价:** ⭐⭐⭐

### Rabby——同类最佳的交易预览

**亮点:**
- ✅ 在你签名前模拟每一笔交易(显示精确的余额变化)
- ✅ 开源
- ✅ 多链切换,无需手动添加网络

**不足:**
- ⚠️ 仅支持浏览器(没有手机端)
- ⚠️ 仅限以太坊生态
- ⚠️ 学习曲线较陡

**适合人群:**希望在签名前查看影响的 DeFi 高级用户。

**评价:** ⭐⭐⭐⭐

### Rainbow——最佳用户体验(但仅限以太坊)

**亮点:**
- ✅ 界面美观、直观
- ✅ 对新手的引导非常友好
- ✅ 开源

**不足:**
- ⚠️ 仅支持以太坊生态
- ⚠️ 防诈骗功能有限
- ⚠️ 存在假币垃圾空投问题

**适合人群:**注重美观、仅使用以太坊的休闲用户。

**评价:** ⭐⭐⭐

### Coinbase Wallet——连接交易所的桥梁

**亮点:**
- ✅ 与 Coinbase 交易所无缝集成
- ✅ 支持多链
- ✅ 值得信赖的品牌

**不足:**
- ⚠️ 防诈骗功能基础
- ⚠️ 存在数据收集方面的担忧(与美国监管趋同)
- ⚠️ 显示所有代币

**适合人群:**正在向自我托管过渡的 Coinbase 交易所用户。

**评价:** ⭐⭐⭐

### Ledger + Ledger Live——最适合长期存储

**亮点:**
- ✅ 硬件隔离——密钥永不接触互联网
- ✅ 支持 100+ 条链
- ✅ 大额资产的最佳解决方案(>10 000 €)

**不足:**
- ⚠️ 设备售价 79 € 至 249 €
- ⚠️ 需要携带实体设备,也有丢失的风险
- ⚠️ 2020 年数据泄露事件(客户邮箱被泄露)
- ⚠️ 没有防诈骗扫描器——你仍然容易受到恶意签名的攻击

**适合人群:**将其作为储蓄金库、持有大额资产的用户。

**评价:** ⭐⭐⭐⭐(仅限长期持有)

## 哪款非托管钱包最适合你?

问自己这 3 个问题:

### 1. 我持有多少加密货币?
- **< 1 000 €** → **Lumina Wallet**(手机端、安全、免费)
- **1 000 € – 10 000 €** → 日常使用 **Lumina Wallet** + 可选的 Ledger 用于储蓄
- **> 10 000 €** → **Ledger** 用于冷存储 + Lumina Wallet 用于日常交易

### 2. 我活跃于 DeFi 吗?
- **不,我只是持有和转账** → **Lumina Wallet**
- **是的,但只是偶尔** → **Lumina Wallet**(内置 WalletConnect)
- **是的,我是每天使用的 DeFi 高级用户** → **Rabby** 或 MetaMask

### 3. 我担心诈骗吗?
- **是的,我听说过一些可怕的故事** → **Lumina Wallet**(三层扫描器)
- **我很谨慎,也懂技术** → MetaMask、Rabby 或 Trust Wallet
- **我只向已知地址转账** → 任何钱包都可以

## 假币问题:一个关键差异

这份清单中的大多数钱包都有一个明显的缺陷:它们会显示区块链发送给它们的**每一种代币**。这意味着当诈骗者向你的地址空投 10 000 个假“USDT”时,MetaMask、Trust Wallet、Rainbow 和 Coinbase Wallet **都会把它们显示出来**,就好像它们是真的一样。

如果你点击出售——你就签署了一份恶意合约。一瞬间,钱包被洗劫一空。

**Lumina Wallet 则不同。**它只显示来自**每条区块链官方合约地址严格白名单**的代币。以太坊上的假 USDT?忽略。BNB Chain 上的假 USDC?忽略。仅此一点就消除了 2026 年排名第一的加密诈骗手段。

阅读我们的完整指南:[假币——Lumina 如何从源头拦截](/en/security)。

## 非托管钱包常见问题

### 2026 年最安全的非托管钱包是哪款?

对大多数用户而言是 **Lumina Wallet**——因为它将自我托管与主动式防诈骗保护结合在一起。对于大额长期持有,则推荐 **Ledger 硬件钱包**。

### 非托管钱包会被黑客攻击吗?

钱包本身不会——私钥保存在你的设备上。但**你**可能会被骗去签署恶意交易。这就是选择带有**交易扫描器**的钱包如此重要的原因。

### Lumina Wallet 真的免费吗?

是的。没有月费,没有高级套餐。Lumina 通过可选服务(通过 Everstake 质押、通过 MoonPay/Transak 购买加密货币)中透明的合作伙伴费用盈利,并且会清楚披露。

### 我应该使用多个钱包吗?

应该。资深加密持有者的做法是:**Ledger 用于储蓄**(占持仓的 90% 以上)+ **Lumina Wallet 用于日常使用**(不到 10%)。每个钱包使用各自独立的助记词。

## 结语:钱包领域已趋于成熟

到了 2026 年,仅仅“非托管”已经不够了。每一款正规钱包都是非托管的。**真正的差异化因素**是防诈骗保护:当你一时疏忽时,钱包能在多大程度上保护你?

我们的推荐:
- **日常用户** → [Lumina Wallet](/en/download)(安全性与易用性的最佳平衡)
- **DeFi 高级用户** → Rabby 或 MetaMask
- **大额资产** → Ledger + Lumina Wallet 组合

**准备好试用 2026 年最安全的非托管钱包了吗?**

[在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "permit-malveillant-erc20-scam": {
    title: "恶意 ERC-20 Permit:无需交易就能掏空你钱包的无声骗局",
    meta: "了解恶意 ERC-20 permit 和 Permit2 签名的运作方式——这是 2026 年最危险的加密货币骗局,无需任何可见的链上交易就能掏空你的钱包。本文介绍如何识别并拦截它们。",
    body: `2026 年,超过 **5 亿美元** 的资金通过同一种手法从加密货币用户手中被盗:**恶意 ERC-20 permit**。这种骗局尤其危险,因为你签名时**不会留下任何可见的链上痕迹**——只是一个不起眼的签名,就能授权攻击者随时掏空你的钱包。

本指南将解释什么是恶意 permit、为什么它在 2026 年成为盗币团伙(drainer)最爱用的骗局,以及最重要的——**如何保护自己**。

## 什么是 ERC-20 Permit?

**permit** 是 2020 年引入 ERC-20 标准的一项扩展(EIP-2612)。它允许用户在**无需发送链上交易**的情况下,**授权**智能合约花费自己的代币。

通俗地说:你不再需要发起一笔要付 gas 费的传统"Approve"交易,而是只需用钱包**签署一条消息**。随后,这条消息由合约自己提交到链上。

**合法用途的好处:**
- ✅ 节省 gas(一笔交易代替两笔)
- ✅ 更好的用户体验(用户只需签名一次,其余自动完成)
- ✅ 被 Uniswap、1inch 和各类 DEX 聚合器采用

**问题在于:**这种签名对大多数钱包来说是**不可见的**。你以为只是点击"签名"来连接网站——实际上却授权了攻击者转走 100 000 USDC。

## 骗局如何分 5 步实施

### 第 1 步 — 诱饵
你点击了 Google 广告或 Discord 链接,进入一个**假冒的 Uniswap**、**假冒的加密货币空投**或**假冒的 NFT 网站**。网站看起来 100% 正规——官方 Logo、专业设计、带有欺骗性的网址(用 \`uniswaap.org\` 代替 \`uniswap.org\`)。

### 第 2 步 — 连接请求
网站提示你"连接钱包"。你点击后 MetaMask 弹出,只显示"签署消息"。**表面上**看不出任何可疑之处。

### 第 3 步 — 隐藏的消息
你看不到的是:这条消息里包含 ERC-20 permit 的参数:
- **owner**:你的地址
- **spender**:攻击者的地址
- **value**:最大数额(通常为 115 792 089 237 316 195... = 无限)
- **deadline**:从现在起 30 天
- **nonce**:你当前的 nonce

你签了名。链上**当下**什么也没发生,你以为什么事都没有。

### 第 4 步 — 利用签名
数小时或数天后,攻击者通过一笔 \`permit()\` + \`transferFrom()\` 交易,将**你的签名**提交到链上。由于签名在数学上有效,智能合约会予以接受。

### 第 5 步 — 盗取资产
你的 USDC、USDT、WETH 或其他任何 ERC-20 代币都会被**转到攻击者的地址**。你在第二天早上才发现损失。

**无法追索。**交易不可撤销,也不涉及任何中心化交易所。

## Permit2:升级版的威胁

**Permit2** 是 Uniswap 在 2022 年提出的扩展,旨在为**所有 ERC-20 代币**统一 permit 机制,即使是那些没有原生实现 EIP-2612 的代币。

它对 DeFi 用户体验来说**技术上堪称精妙**,但对安全而言却是**灾难性的**,原因如下:
- 一个 Permit2 签名即可同时授权花费**多种代币**
- 签名可在**数天甚至数周**内保持有效
- 大多数钱包只把 Permit2 显示为一条没有细节的普通"消息"

**结果:**现代盗币团伙优先使用 Permit2,因为它让盗取**更高效、更隐蔽**。

## 如何识别恶意 Permit

### 危险信号 #1:签名格式
Permit 或 Permit2 签名在你的钱包中总是以 **EIP-712 类型化消息** 的形式出现,结构如下:

\`\`\`
Domain: PermitToken or Permit2
Types:
  Permit: [owner, spender, value, nonce, deadline]
Message:
  owner: 0xYOUR_ADDRESS
  spender: 0xUNKNOWN  ← THIS is suspicious
  value: 115792089237316195423570985008687907853269984665640564039457584007913129639935  ← That's infinity!
  deadline: 1735689600
\`\`\`

### 危险信号 #2:场景
- 你刚进入一个**从未用过**的网站 → 🔴
- 网站提供**免费空投**或**异常高的收益** → 🔴
- 网站**在展示内容之前**就要求你签名 → 🔴
- 网址存在**细微的拼写错误**(uniswaap 而不是 uniswap)→ 🔴

### 危险信号 #3:陌生的 spender
\`spender\` 字段(即将花费你代币的合约)必须是**已知且经过验证**的合约。如果它是一个随机地址,且在 Etherscan 上没有显示为已验证合约,**那就是骗局。**

## Lumina Wallet 如何保护你

Lumina Wallet 会在要求你签名之前,解码**每一个** Permit 和 Permit2 签名。具体流程如下:

1. **签名解码**:Lumina 解析 EIP-712 消息,并判断它是否为 permit
2. **spender 验证**:目标合约是已知的 DEX/协议(Uniswap、1inch、Aave……),还是一个未知地址?
3. **金额警报**:如果金额为"无限"(2^256 - 1),会弹出严重警报
4. **通俗语言翻译**:你看到的不是一长串十六进制数据,而是:*"你正在授权 [未知合约] 在未来 30 天内、不设上限地花费 [你的全部 USDC]"*

结果:在签名之前,你能**清楚看到**自己签的是什么。恶意 permit 也就不可能被你误签了。

## 如果你已经签署了恶意 Permit,该怎么办

### 第 1 步 — 不要慌张,迅速行动
这个 permit 可能还没有被利用。在攻击者使用你的签名之前,你还有**一个时间窗口**。

### 第 2 步 — 转出有风险的代币
立即将你所有的 ERC-20 代币转移到一个**全新的干净钱包**。请使用带有新助记词的全新钱包,不要重复使用已被入侵的钱包。

### 第 3 步 — 撤销现有授权
前往 [revoke.cash](https://revoke.cash) 撤销所有授权。**重要提示:**revoke.cash **无法**撤销尚未被利用的链下 Permit 签名,你只能转移代币。

### 第 4 步 — 举报欺诈网站
- ScamAdviser
- Google Safe Browsing
- Chainabuse.com

### 第 5 步 — 弃用被入侵的钱包
永远不要再使用签署过恶意 permit 的钱包,即使你没有损失任何资产。视具体情况,你的签名 nonce 仍可能被利用。

## 专家共识

- **Vitalik Buterin(以太坊联合创始人)** 于 2024 年在 X 上公开警告过 Permit2 的风险。
- **Chainalysis** 将"恶意 permit 签名"认定为 **2025 年排名第一的加密货币盗窃手法**,超过了传统的 ERC-20 授权。
- **PeckShield** 记录到仅 2025 年就发生了 300 多起恶意 permit 攻击。

## 结语:隐形签名是新的危险

可见的链上交易时代已经过去。2026 年,最危险的骗局在你确认时**不会留下任何可见的痕迹**。一个链下签名,无声无息、延迟生效——第二天你的钱包就空了。

**唯一有效的防御:**在你确认之前,**用通俗语言解码每一个签名**的钱包。这正是 Lumina Wallet 所做的——无论是 Permit、Permit2,还是所有恶意的 EIP-712 签名。

**立即保护自己:**

[在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "how-to-set-up-non-custodial-wallet-2026": {
    title: "2026 年如何设置非托管加密钱包：完整分步指南",
    meta: "了解 2026 年如何设置非托管加密钱包——完整分步教程，涵盖钱包选择、助记词备份、安全设置以及你的第一笔交易。适合新手阅读。",
    body: `设置一个**非托管加密钱包**，是你加密货币之旅中最重要的一步。做对了，你就真正拥有自己的加密资产——没有银行、没有交易所、没有任何第三方可以冻结或弄丢你的资金。做错了，一个失误就可能让你损失一切。

这份分步指南将带你走完 2026 年的**整个流程**，从选择合适的钱包到你的第一笔安全交易。没有晦涩术语，也没有捷径。

## 开始之前：3 条黄金法则

### 法则 1 — 绝不分享你的助记词
你的 12 或 24 个单词的助记词是整个钱包的主密钥。**任何正规的个人、应用或网站都不会向你索要助记词。** 即使是你所用钱包的开发者也不会。如果有人向你索要，那 100% 是诈骗。

### 法则 2 — 绝不以数字方式存储助记词
不要拍照，不要截图，不要存在云笔记里，也不要存进任何联网的密码管理器。绝对不要。把它写在**纸**上，或者刻在**金属**上。并将纸张存放在物理上安全的地方。

### 法则 3 — 始终从官方网站下载
App Store 和 Google Play 上的假冒钱包应用，会在你输入助记词的瞬间将其窃取。请只从钱包的**官方网站**下载（例如 https://luminawallet.org），切勿通过 Google Play 或 App Store 的搜索结果下载。

## 步骤 1 — 选择合适的非托管钱包

对于 2026 年的新手，我们推荐 **Lumina Wallet**，原因如下：
- ✅ 设计上即为非托管（密钥由你掌握）
- ✅ 内置防诈骗扫描器（帮你避免自己的失误）
- ✅ 从第一天起就支持多链（Bitcoin、Ethereum、Solana、XRP、BNB Chain、Polygon……）
- ✅ 免费下载
- ✅ 法国公司（HEDONISME SARL），所有权透明

根据你的情况，也可以考虑以下替代方案：
- **MetaMask** — 适合高级 DeFi 用户
- **Ledger** — 适合长期持有超过 10 000 € 的用户（硬件钱包）
- **Rabby** — 适合每天在浏览器上使用 DeFi 的用户

请查看我们的完整文章：[2026 年最佳非托管钱包对比](/en/blog/best-non-custodial-crypto-wallet-2026)。

## 步骤 2 — 从官方渠道下载应用

以 Lumina Wallet 为例：
1. 打开手机浏览器（iOS 上用 Safari，Android 上用 Chrome）
2. 直接输入 **luminawallet.org**（不要用 Google 搜索——Google 广告可能是假的）
3. 点击 **“Download”** 按钮
4. 你将被重定向到官方的 Google Play Store 或 App Store 页面

安装前请核实：
- ✅ 开发者名称：**Lumina Wallet**
- ✅ App Store ID：**id6760651380**
- ✅ Google Play 包名：**com.luminawallet.app**
- ✅ 下载量 > 1 000（假冒克隆应用的下载量非常少）

确认身份无误后，再安装应用。

## 步骤 3 — 创建新钱包（而非导入）

首次打开应用时，你会看到两个选项：
- **“Create New Wallet”（创建新钱包）** ← 选择这个
- **“Import Existing Wallet”（导入已有钱包）** ← 仅在你已有助记词时使用

点击 **Create New Wallet**。应用会**在你的设备本地**生成私钥。私钥绝不会经过我们的服务器、我们的开发人员或互联网。

## 步骤 4 — 备份你的助记词（关键一步）

应用此时会按特定顺序显示 **12 或 24 个单词**，这就是你的**恢复助记词**。

### 如何正确备份：

1. **准备纸和笔**（不要用手机）。
2. **按顺序写下单词**，每行一个，并在每个单词旁标注序号。
3. **仔细核对每个单词**——只要拼错一个字母，你就无法恢复钱包。
4. **逐个单词**与应用中的内容对照，核实拼写。
5. 将纸张**存放**在物理上安全的地方：上锁的抽屉、家用保险箱、银行保险箱。
6. **再备份一份**，存放在**不同的物理位置**（例如交给值得信任的家人）。
7. **绝不要拍照。** 绝不要保存在备忘录、iCloud、Google Drive 或任何云服务中。

**可选的进阶方案：** 将助记词刻在不锈钢上（使用 Cryptosteel、Billfodl 等套件，或一套简单的金属冲压字模）。防火、防水，经久耐用。

### 绝对不要这样做：
- ❌ “只是为了备份”而拍一张照片
- ❌ 通过电子邮件发给自己
- ❌ 存放在在线密码管理器中
- ❌ 保存在手机的备忘录应用里
- ❌ 与任何人分享（配偶、家人、“客服人员”）

## 步骤 5 — 确认你的助记词

应用会要求你**验证**自己是否正确抄写了助记词。它会显示几个位置（例如第 3 个、第 7 个、第 11 个单词），并要求你从列表中点选正确的单词。

如果验证失败，应用不会将你锁定——但这强烈表明你没有正确备份。请**重新备份**，直到你能对照纸上的内容完成确认。

## 步骤 6 — 设置高强度钱包密码

创建一个**高强度密码**，用于在设备上解锁应用：
- 至少 **14 个字符**
- 混合大写字母、小写字母、数字和符号
- **与你使用的所有其他密码都不同**
- 将其存放在密码管理器中（Bitwarden、1Password、KeePass）

此密码会在本地加密你的密钥。即使有人偷走你的手机，没有这个密码也无法打开 Lumina Wallet。

## 步骤 7 — 启用生物识别 + PIN 码

在钱包的“设置”菜单中，启用：
- ✅ **Face ID** 或**指纹**（iOS/Android 生物识别）
- ✅ **PIN 码**（6 位数字，且与手机解锁 PIN 不同）

现在，你的钱包受到**三层身份验证**保护：
1. 手机解锁（Face ID / PIN）
2. 钱包 PIN（6 位数字）
3. 钱包密码（14 位以上字符）

即使小偷拿到了已解锁的手机，也无法访问你的加密资产。

## 步骤 8 — 用小额测试交易验证一切

在存入任何较大金额之前：

1. 从交易所（Coinbase、Binance、Kraken）向你新钱包的地址转入价值 **5 € 到 10 €** 的加密货币。
2. 等待交易确认（通常需要 1-15 分钟，取决于区块链）。
3. 再把它**转回**交易所，作为另一次测试。

如果两次都成功，说明你的钱包设置正确。**在完成这项测试之前，切勿存入大额资金。**

## 步骤 9 — 用防诈骗扫描器练习

Lumina Wallet 内置的扫描器可以保护你免受常见诈骗。不妨亲自测试一下：

- **尝试向一个明显虚假的地址转账**（例如 0x000...000）→ Lumina 会拦截
- **尝试扫描一个与加密货币无关的二维码** → Lumina 会拒绝
- **签名前查看交易预览** → Lumina 会显示将要转出的确切代币

**现在**就熟悉这些警告，意味着当真正的诈骗出现时，你能够认出它们。

## 步骤 10 — 到这一步，才可以存入真实资金

当你已经：
- ✅ 确认了助记词备份
- ✅ 设置了生物识别 + PIN + 密码
- ✅ 成功完成了测试交易
- ✅ 用扫描器进行了练习

……**这时**你才可以开始存入真实金额。

对于认真的持有者，推荐的做法：
- **日常钱包**：这里只放你全部加密资产的 <10 %（用于消费、DeFi、兑换）
- **储蓄金库**：大额资金请使用硬件钱包（Ledger），搭配另一组助记词，并离线存放

## 破坏钱包安全的常见错误

即使遵循本指南的用户，有时也会犯这些错误。请务必避免：

- ❌ **“只是为了备份”而截图保存助记词**——iCloud 会把它同步到云端
- ❌ **钱包和邮箱使用相同的密码**
- ❌ **点击钱包应用的 Google 广告**（假冒克隆应用常借助 Google 广告传播）
- ❌ **因为赶时间而无视安全警告**
- ❌ **为了“测试”空投而连接来路不明的 DApp**

## 设置非托管钱包常见问题

### 设置一个非托管钱包需要多长时间？

如果你认真按本指南操作，大约需要 **15 到 20 分钟**。其中大部分时间都花在正确抄写并核对助记词上。

### 在手机上输入助记词安全吗？

只有在**以下特定场景**才安全：在**官方钱包应用内**设置新钱包，或恢复已有钱包。切勿在网站、客服聊天窗口或任何其他应用中输入助记词。

### 我可以在多个钱包中使用同一个助记词吗？

可以。助记词是主密钥——你可以将其导入任何兼容 BIP-39 的钱包（Lumina、MetaMask、Trust Wallet、Ledger……），并访问相同的账户。不过，最佳做法是**针对不同用途使用不同的助记词**（日常使用 vs. 储蓄）。

### 如果我丢了手机怎么办？

如果你已经写下了助记词：在新手机上安装 Lumina Wallet，选择“Import Existing Wallet”，输入你的助记词——你的资金会立即恢复。

如果你没有写下助记词：你的加密资产将**永久丢失**，没有任何例外。

## 结语：设置到位，高枕无忧

设置非托管钱包是一次**一劳永逸的投入**，它决定了你的加密资产未来数年的安全。请多花 5 分钟正确抄写助记词，启用所有安全层级，并先用小额进行测试。

**Lumina Wallet** 旨在让这一过程尽可能安全——无论你今天多么谨慎，它的防诈骗扫描器都能拦截你日后可能犯下的失误。

**准备好设置你的第一个非托管钱包了吗？**

[在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "unhosted-wallet-vs-custodial-wallet": {
    title: "非托管钱包 vs 托管钱包:2026 年监管指南",
    meta: "什么是“unhosted wallet(非托管钱包)”?了解 unhosted 钱包与托管钱包的区别——这是美国财政部对非托管钱包的称呼——以及它对 2026 年加密货币监管、隐私和自我托管意味着什么。",
    body: `如果你最近读过美国财政部或 FinCEN 的相关文件,很可能见过 **“unhosted wallet”(非托管钱包)** 这个术语。它是监管语境中对加密社区所说的 **非托管钱包(non-custodial wallet)** 的称呼——但在 2026 年,两者之间存在一些值得注意的细微差别。本指南将说明什么是 unhosted 钱包,它与托管钱包有何不同,以及这一术语为何对隐私、合规和自我托管至关重要。

## 什么是 Unhosted 钱包?

**Unhosted 钱包** 是指私钥由用户本人而非第三方服务提供商控制的加密货币钱包。在美国金融监管机构(主要是 FinCEN(金融犯罪执法网络)和美国财政部)的语言中,“unhosted”的意思是:**不由受监管的金融机构托管**。

**具体来说,unhosted 钱包具有以下特点:**
- ✅ **你**自己持有私钥
- ✅ 不由银行、交易所或任何注册的货币服务业务(MSB)运营
- ✅ 无需经过 KYC 流程即可访问

**2026 年常见的同义词:**
- 非托管钱包(行业术语)
- 自我托管钱包(科普术语)
- 个人钱包(非正式说法)

## Unhosted 与托管:主要区别

| 特性 | Unhosted 钱包 | 托管钱包 |
|---|---|---|
| **谁持有私钥?** | 你 | 受监管的第三方(交易所、银行) |
| **是否需要 KYC?** | 否 | 是(身份验证) |
| **账户能否被冻结?** | 不能——没有人拥有这种权力 | 可以——托管方可应请求冻结 |
| **监管报告?** | 有限(因司法管辖区而异) | 完整(每笔交易都会上报给当局) |
| **法律上谁拥有资金?** | 你本人直接拥有 | 托管方代你保管 |
| **破产风险?** | 无 | 有——你是无担保债权人 |
| **示例** | Lumina Wallet、MetaMask、Ledger | Coinbase、Binance、Kraken(其默认账户) |

## 监管机构为何使用“Unhosted”这一术语

“unhosted”一词在 **2020 年 12 月 FinCEN 的一项拟议规则** 中频繁出现,该规则本将要求交易所对超过一定门槛、与 unhosted 钱包之间的交易收集身份信息。

该规则:
- **未以原始形式获得通过**(遭到行业强烈反对)
- 部分内容已纳入 **2024 年美国加密资产报告框架**
- 属于 G7/FATF 在加密货币 **Travel Rule(旅行规则)** 上更广泛协调的一部分

2026 年,“unhosted wallet”这一术语最常出现在:
- 美国财政部和 FinCEN 的文件
- FATF(金融行动特别工作组)的建议
- 欧洲 MiCA(加密资产市场)法规
- 国会关于加密货币政策的证词

## 使用 Unhosted 钱包合法吗?

**合法。** 在 2026 年,使用 unhosted 钱包在美国、欧盟、英国、法国以及几乎所有民主国家都是 **完全合法** 的。

受监管的内容包括:
- **交易所与 unhosted 钱包之间** 的交易(须遵守报告门槛)
- 涉及 unhosted 钱包的某些商业活动(资金转移、托管服务)
- **不包括** 个人单纯持有或使用 unhosted 钱包

需要明确的是:**2026 年,你在法国和欧盟可以合法地拥有、使用 unhosted 钱包,并从中发送或向其接收加密货币——无需任何许可或授权。**

## 隐私的取舍

与托管钱包相比,unhosted 钱包提供 **更多隐私**,因为:
- 创建时无需 KYC
- 不向中央机构报告交易
- 不会被中介机构拦截交易

不过,这种隐私 **并非绝对**:
- 区块链交易会 **永久公开可见**
- 如果你的身份与你的地址相关联(通过交易所、dApp、KYC 事件),你的全部链上历史都将变得可追溯
- **链上分析公司**(Chainalysis、Elliptic、TRM Labs)会积极监控区块链活动

要在 2026 年获得切实的隐私保护,你需要:
- 一个 unhosted 钱包
- 谨慎使用交易所(尽可能使用现金转加密货币的通道)
- 注重隐私的工具(混币器、隐私币或 ZK 隐私协议)

⚠️ **注意:** 针对隐私工具的法规仍在不断变化。涉及高价值资产或商业用途时,请咨询当地律师。

## Unhosted 钱包与 MiCA(欧洲)

**欧盟的 MiCA 法规**(加密资产市场法规)自 2024 年 12 月起全面适用,对 unhosted 钱包的规定如下:

- **个人** 可以自由使用 unhosted 钱包——无需报告
- **加密资产服务提供商(CASP)**——交易所、托管机构——对于与 unhosted 钱包之间超过 **1 000 €** 的交易,必须收集身份数据(“Travel Rule”)
- 个人之间 unhosted 到 unhosted 的交易仍然 **不受监管**

实际上,作为法国用户,你可以自由使用 Lumina Wallet,向其接收加密货币并从中发送——无需承担任何特殊义务。

## Unhosted 钱包安全:你需要了解的事项

由于 unhosted 钱包让你拥有完全的控制权,你也需要承担 **全部责任**:

### 好的一面:
- ✅ **没有第三方** 可以冻结你的资金
- ✅ **不会因托管方破产** 而损失资金
- ✅ 默认拥有 **完整隐私**
- ✅ 无需中介即可 **直接访问 DeFi**

### 需要取舍的一面:
- 🔴 **丢失助记词 = 丢失资金**(没有“忘记密码”功能)
- 🔴 **被钓鱼 = 丢失资金**(无法撤销)
- 🔴 **签署恶意合约 = 丢失资金**(完全由你自己负责)

因此,选择一款带有 **内置防诈骗保护** 的 unhosted 钱包——例如 Lumina Wallet——能显著改善风险与收益的平衡。你既保留了自我托管的自由,又为自己的失误增加了一道安全网。

## 你应该使用 Unhosted 钱包吗?

**适合使用,如果:**
- 你希望真正拥有自己的加密资产
- 你认真对待长期持有
- 你想使用 DeFi、NFT 或 Web3 应用
- 你担心交易所破产或账户被冻结
- 你重视隐私

**不适合使用,如果:**
- 你只是偶尔在中心化交易所交易
- 你不习惯自己管理助记词
- 你需要托管服务提供的“忘记密码”安全保障
- 对你来说,监管报告的简便比自我托管更重要

对大多数认真的加密用户来说,答案是:**两者兼用**。将活跃交易的资金留在受监管的交易所,把长期持有的资产转入 unhosted 钱包。

## 常见问题:Unhosted 钱包

### “Unhosted 钱包”与“冷钱包”是一回事吗?

不完全是。**“Unhosted”** 描述的是谁控制私钥(你,而不是第三方)。**“冷”** 描述的是私钥存储在哪里(离线还是在线)。一个钱包可以既是 unhosted 又是热钱包(Lumina、MetaMask),也可以既是 unhosted 又是冷钱包(Ledger、Trezor)。

### 我需要在纳税申报中申报我的 unhosted 钱包吗?

在法国,自 2020 年起,你必须在 3916-BIS 表格上申报 **境外数字资产账户**。直接持有的 unhosted 钱包(不经托管方)通常 **不受此义务约束**,但报告规则仍在演变。请就你的具体情况咨询税务专业人士。

### 政府可以查封 unhosted 钱包中的加密货币吗?

只有在他们掌握私钥,或通过法律程序迫使你交出私钥时才可以。已有记录显示,当局曾通过搜查令或认罪协商获取助记词,从而查封加密货币。**密码学意义上的所有权并不等同于法律豁免。**

### 哪款 unhosted 钱包最适合新手?

**Lumina Wallet** 专为希望自我托管、又不想成为加密专家的用户而设计。内置的诈骗防护可以拦截最常见的失误,而多链支持(Bitcoin、Ethereum、Solana、XRP、BNB、Polygon……)涵盖了你实际会用到的一切。

## 结论

“Unhosted wallet”是监管机构对 **非托管钱包** 的称呼——它是 2026 年拥有加密资产的基础工具。理解这个术语,有助于你把握政策讨论、完成税务申报,并适应 MiCA 时代的合规要求。

总而言之:unhosted 钱包 **合法、强大,而且会长期存在**。选择一款将自我托管与实用保护相结合的钱包——例如 Lumina Wallet——你就能两全其美。

**准备好尝试现代化的 unhosted 钱包了吗?**

[在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "non-custodial-wallet-app-2026-mobile-guide": {
    title: "非托管钱包应用:2026 年移动端用户终极指南",
    meta: "正在寻找 2026 年最好的非托管钱包应用?这份以移动端为核心的完整指南涵盖:应有的功能、必备安全要素、5 款顶级 iOS/Android 应用对比,以及如何在 App Store 识别假冒克隆应用。",
    body: `在 2026 年寻找一款**非托管钱包应用**并不容易。App Store 和 Google Play 上有数百款应用,每一款都声称自己最安全、最易用或功能最丰富。其中有些确实非常出色,有些则纯属骗局(专门用来窃取助记词的假冒克隆应用)。本指南完全聚焦移动端——不涉及浏览器扩展,也不涉及硬件钱包——为您提供一套实用的框架,帮助您选对应用并避开陷阱。

## 什么是非托管钱包应用?

**非托管钱包应用**是一种移动应用(iOS 或 Android),具有以下特点:
- **您**持有私钥——私钥在手机本地加密存储
- **任何交易所、银行或第三方**都无法冻结或丢失您的加密资产
- **您的助记词**在本地生成,绝不会离开您的设备
- 访问受生物识别 + PIN 码 + 密码的多重保护

2026 年最好的移动端非托管钱包支持 10 条以上区块链,通过 WalletConnect 与 Web3 应用集成,而且——至关重要的是——应用内直接内置了**防诈骗保护**。

## 为什么 2026 年移动端比桌面端更重要

超过 **72% 的加密货币交易**在 2026 年发生在移动设备上(Chainalysis 2026 State of Crypto)。移动优先的非托管钱包已经超越浏览器扩展,原因如下:

- 🔐 现代手机配备**硬件安全模块**(iOS Secure Enclave、Android Keystore),这是浏览器无法比拟的
- 📱 **生物识别认证**(Face ID、指纹)已成为标配
- 🚀 **推送通知**会即时提醒您有转入交易
- 📷 **摄像头 + 二维码扫描**让地址输入更安全
- 🌐 **WalletConnect v2** 让移动钱包可以为桌面 dApp 签名

## 2026 年五大非托管钱包应用

### 🥇 Lumina Wallet — 最注重安全的移动钱包
- **平台:** iOS + Android
- **链:** Bitcoin、Ethereum、Solana、XRP、BNB Chain、Polygon、Arbitrum、Optimism、Base、Avalanche
- **独特功能:** 三层防诈骗扫描器(二维码读取器、地址审计、交易解码器)+ [假币白名单过滤器](/en/security)
- **适合人群:** 希望获得最大程度保护,又不想成为加密专家的用户
- **免费**——无需订阅

### 🥈 Trust Wallet — 支持的链最广泛
- **平台:** iOS + Android
- **链:** 70+
- **缺点:** 默认显示所有代币(存在假币垃圾空投风险),防诈骗保护较为基础
- **适合人群:** 活跃于众多冷门链的用户

### 🥉 MetaMask Mobile — DeFi 标准
- **平台:** iOS + Android
- **链:** EVM 链、Solana 和 Bitcoin
- **缺点:** 仅有基础警告,没有假币过滤器,历来存在用户体验摩擦
- **适合人群:** 已经熟悉浏览器版 MetaMask 的用户

### Rainbow — Ethereum 上用户体验最佳
- **平台:** iOS + Android
- **链:** 仅限 Ethereum 生态
- **缺点:** 多链支持有限
- **适合人群:** 注重设计的 Ethereum 休闲用户

### Coinbase Wallet — 最适合 Coinbase 用户
- **平台:** iOS + Android
- **链:** 20+
- **缺点:** 防诈骗功能基础,存在数据收集方面的顾虑
- **适合人群:** 从 Coinbase 交易所过渡到自我托管的用户

## 2026 年的四项必备功能

在比较非托管钱包应用时,请坚持要求以下四项功能缺一不可:

### 1. 带硬件安全保护的本地密钥存储
私钥应使用 iOS Secure Enclave 或 Android Keystore 加密。**如果应用以明文或云同步方式存储密钥——请立即放弃。**

### 2. 内置防诈骗扫描器
2026 年每一款名副其实的钱包都应该:
- 对照已知恶意地址列表扫描收款地址
- 用通俗易懂的语言解码 ERC-20 Permit / Permit2 签名
- 在签名前模拟交易(显示将转出的确切代币)
- 对"无限授权"模式发出警告

### 3. 假币过滤器
这是 **2026 年最大的差异化因素**。骗子会向数百万个钱包空投 10 000 枚假冒的"USDT"代币。显示所有代币的钱包十分危险。请选择按区块链使用**官方合约地址白名单**的钱包(Lumina 目前在这方面处于领先地位)。

### 4. 从第一天起就支持多链
一组助记词就应能生成 Bitcoin、Ethereum、Solana、XRP、BNB Chain 以及其他主要网络的地址,无需在多个应用之间来回切换。

## 如何在 App Store 识别假冒钱包应用

**假冒克隆应用**是 2026 年的一大威胁。它们会复制 Lumina Wallet 的名称、徽标和描述——然后在您输入助记词的瞬间将其窃取。

**下载前的验证清单:**

- ✅ 只从**官方网站**下载(例如 https://luminawallet.org)。切勿在 App Store 中搜索。
- ✅ 核对**开发者名称**是否完全一致(Lumina Wallet 的发布者是 *Lumina Wallet*)
- ✅ 检查**包名 ID**:正版 Lumina = \`com.luminawallet.app\`
- ✅ 检查 **App Store ID**:正版 Lumina = \`id6760651380\`
- ✅ 下载量 > 1 000(假冒克隆应用通常不足 100)
- ✅ 阅读评论——克隆应用的评论往往是整齐划一、可疑的 5 星好评

📖 阅读我们的完整指南:[假冒加密钱包克隆应用](/en/blog/fake-crypto-wallet-clones)

## 非托管钱包应用常见问题

### 非托管钱包应用比交易所应用更安全吗?

对于中长期存储,**是的**。非托管钱包无法在平台层面被攻破——每位用户的密钥都分别存放在各自的设备上。而交易所应用是攻击者持续瞄准的"蜜罐"。

### 非托管钱包应用需要付费吗?

像 **Lumina Wallet** 这样一流的应用是 100% 免费的。部分钱包通过可选服务(质押、购买加密货币)中透明的合作伙伴费用获利。请警惕那些为基础钱包功能索要"高级订阅"的应用。

### 我可以在多部手机上使用同一个非托管钱包应用吗?

可以——在两部手机上都安装该应用,并分别导入您的助记词。两部手机将显示相同的余额,并且可以各自独立发送交易。请务必小心:任何拥有您助记词的手机都具有完全的访问权限。

### 如果钱包应用的开发者消失了会怎样?

您的加密资产依然安全。非托管意味着应用只是一个界面——您的密钥对应的资产在区块链上。即使 Lumina Wallet 有一天消失了,您也可以将助记词导入**任何兼容 BIP-39 的钱包**(MetaMask、Trust Wallet、Ledger……),恢复完整访问权限。

## 结语:选择一款您能信赖多年的钱包应用

在未来的数年里,您将在非托管钱包应用中与自己的加密资产互动**数百次**。请选择一款既能实现自我托管、又能主动防范 2026 年各类威胁(恶意签名、假币、钓鱼地址)的应用。

**Lumina Wallet** 正是为此而生:这是一款移动端非托管钱包,具备三层防诈骗扫描器、仅显示官方合约代币的功能,并支持 10 条以上区块链。免费、透明(法国公司 HEDONISME SARL,RCS Dunkerque 901 439 505),不收集任何数据。

**准备好试用 2026 年最安全的非托管钱包应用了吗?**

[在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "metamask-vs-lumina-wallet-anti-scam-comparison": {
    title: "MetaMask 对比 Lumina Wallet:2026 年防诈骗能力对比",
    meta: "2026 年该选 MetaMask 还是 Lumina Wallet?一份毫不留情的逐项对比,聚焦防诈骗保护:假代币过滤、签名解码、地址扫描、多链支持与移动端体验。",
    body: `**MetaMask** 是全球最受欢迎的非托管钱包,月活跃用户超过 3000 万。**Lumina Wallet** 则是一款较新的、以移动端优先的挑战者,专为防诈骗保护而打造。2026 年你应该选哪一个?这份逐项对比聚焦于当今加密世界中最重要的一件事:每款钱包在多大程度上能保护你不被洗劫一空。

## 快速结论

- **如果符合以下情况,请选择 MetaMask:** 你是经验丰富的 DeFi 用户,主要在浏览器上使用,并且在签名前懂得阅读 Solidity 函数调用。
- **如果符合以下情况,请选择 Lumina Wallet:** 你想要一款能替你识别诈骗的移动钱包,在你犯下代价高昂的错误之前就拦住它。

对于 2026 年的大多数用户来说,答案是 **Lumina Wallet**。原因如下。

## 逐项对比

| 功能 | MetaMask | Lumina Wallet |
|---|---|---|
| **平台** | 浏览器 + 移动端 | 仅移动端(iOS + Android) |
| **支持的链** | EVM 链、Solana 和 Bitcoin | 10+ 条,包括 BTC、ETH、SOL、XRP、BNB |
| **密钥存储** | 浏览器存储 / 移动端 Keystore | iOS Secure Enclave / Android Keystore |
| **防诈骗地址扫描** | ⚠️ 基础(仅黑名单) | ✅ 实时 GoPlus + 自研扫描器 |
| **假代币过滤** | ❌ 显示所有代币 | ✅ 按官方合约白名单过滤 |
| **ERC-20 Permit 解码器** | ⚠️ 显示原始十六进制数据 | ✅ 通俗易懂的文字翻译 |
| **Permit2 解码器** | ⚠️ 基础 | ✅ 完整解码,并检查金额与 spender |
| **交易模拟** | ⚠️ 基础(仅限以太坊) | ✅ 多链模拟 |
| **地址簿(防输错)** | ❌ 无 | ✅ 有 |
| **开源** | ✅ 是 | ⚠️ 暂未(已计划) |
| **公司透明度** | ⚠️ Consensys(美国) | ✅ HEDONISME SARL(法国)— 可通过 RCS 查证 |
| **价格** | 免费 | 免费 |

## 最大的差异:假代币过滤

2026 年,**排名第一的加密诈骗**是恶意空投。骗子会部署与真币同名、同 Logo 的假 USDT、USDC 或 WETH 代币,然后向数百万个钱包空投 10 000 枚。当你点击卖出时,就会签署一份恶意合约 → 你的钱包被洗劫一空。

### MetaMask 如何处理
MetaMask 会显示区块链发送给你的**每一种代币**。如果有人向你的地址空投假 USDT,它会出现在你的钱包里,名称和 Logo 都与真币一模一样。你需要手动在 Etherscan 上核对合约地址才能确认真伪。大多数用户不会这么做。

### Lumina Wallet 如何处理
Lumina 对每条区块链采用**严格的官方合约地址白名单**。只有来自以太坊真实合约(0xdAC17F...)的 USDT 才会显示。假代币完全不可见,无需用户做任何操作。

阅读我们的完整深度解析:[Lumina 如何从源头拦截假代币](/en/security)

## 签名解码:无声的诈骗防线

恶意的 ERC-20 Permit 和 Permit2 签名在 2026 年让用户损失了**超过 5 亿美元**(参见我们的[完整指南](/en/blog/malicious-erc20-permit-scam))。它们之所以奏效,是因为大多数钱包把签名显示为晦涩的十六进制数据,用户并不明白自己签署的是什么。

### MetaMask 的签名处理
MetaMask 会将 Permit 签名显示为格式化的 EIP-712 消息,但细节非常技术化。\`spender\`、\`value\`、\`nonce\` 等字段虽然可见,却没有任何解释。普通用户常常会忽略“无限授权”的标记。

### Lumina Wallet 的签名处理
在要求你签名之前,Lumina 会**将每一个签名解码**为通俗易懂的文字:
- “你正在授权 [合约名称 / 未知合约] 花费你的 [代币] 共 [金额 / 无限],期限为 [时长]”
- 对无限额度发出严重警报
- 如果 spender 不是已验证的合约,则亮起红色警示

具体效果:在签名之前,你就能清楚地知道自己签署的是什么。

## 多链支持

MetaMask 最初是一款**以太坊钱包**。自 2025 年起，它通过多链账户原生支持 Solana 和 Bitcoin ([MetaMask](https://metamask.io/news/multichain-accounts))。它不原生支持 XRP，内置列表之外的网络仍需手动添加，对新手来说略有门槛。

Lumina Wallet 从第一天起就是**多链钱包**:Bitcoin、Ethereum、Solana、XRP、BNB Chain、Polygon、Arbitrum、Optimism、Base、Avalanche。一套助记词,一个应用,一切开箱即用。

## 用户体验:移动端的现实

**事实:** MetaMask 的移动应用多年来一直因操作笨拙、dApp 浏览器缓慢以及 WalletConnect 连接问题而受到批评。8.0 版本(2026)有所改进,但在设计上仍明显落后于移动端优先的钱包。

**Lumina Wallet** 从一开始就作为移动应用打造,具备:
- 即时交易预览
- 生物识别解锁
- 由移动端 UX 设计师设计的简洁现代界面
- 原生支持 WalletConnect v2

## MetaMask 的优势所在

MetaMask 不会消失。它在 2026 年的优势:

- ✅ **生态主导地位**:99% 的 dApp 都将“使用 MetaMask 连接”作为默认选项
- ✅ **浏览器扩展**:更适合重度使用桌面端的 DeFi 高级用户
- ✅ **Snaps 生态**:可通过第三方插件扩展功能
- ✅ **开源**:代码公开,可审计

如果你是具备冷存储自律习惯的 DeFi 高级用户,MetaMask 完全够用。但在 2026 年,安全性与易用性之间的权衡已经发生变化,主流用户正在转向 Lumina。

## MetaMask 与 Lumina Wallet 常见问题

### 我可以两个都用吗?

可以,很多用户都这样做。常见的模式是:在桌面端用 MetaMask 进行高级 DeFi 操作,在移动端用 Lumina Wallet 处理日常交易以及任何在压力下的签名。

### 两者的助记词兼容吗?

兼容。两者都使用 BIP-39 标准,因此你可以把同一套助记词导入任一钱包,并访问相同的账户。

### 哪一个更安全?

就**基础密钥存储**而言:两者都很安全(非托管,本地加密)。就**对诈骗的主动防护**而言:得益于假代币过滤、签名解码器和多链扫描器,Lumina Wallet 在 2026 年明显领先。

### 哪一个更快?

两者处理基础交易都很快。在 dApp 交互方面,MetaMask 的浏览器扩展在桌面端更快。Lumina Wallet 的移动应用则比 MetaMask Mobile 更快。

## 结论:不同的用户,不同的钱包

对于重视生态兼容性和开源的 DeFi 高级用户来说,MetaMask 仍然是行业标准。Lumina Wallet 则是为那些优先考虑**应对 2026 年威胁格局**(恶意签名、假代币、钓鱼地址)的用户提供的现代答案。

如果你曾因为没有完全理解交易的作用就点击“签名”而感到紧张,**Lumina Wallet 正是为你打造的**。

**准备好试用 2026 年的防诈骗钱包了吗?**

[在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [在 App Store 下载](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "guide-wallet-non-custodial-2026": {
    title: "非托管加密钱包:2026 年完全指南",
    meta: "2026 年非托管加密钱包究竟是什么、与托管型交易所有何不同、如何选择,以及在转移任何一枚聪之前必须遵循的安全清单。专为大众用户撰写。",
    body: `**非托管加密钱包**是指**只有你自己持有私钥**来控制资金的钱包。任何公司、交易所或第三方都无法代替你冻结、没收或丢失你的资产。2026 年,在经历了十年间交易所接连崩盘(FTX、Celsius、Mt. Gox)以及数十亿美元用户资金被冻结之后,非托管钱包已从小众选择变成几乎所有安全研究人员的默认推荐 [1]。

本指南用通俗易懂的语言,讲解非托管钱包的工作原理、与托管方案的区别、选择自我托管时需要接受的取舍,以及在 2026 年挑选一款值得信赖的钱包的实用清单。

## 2026 年的定义:什么是非托管钱包

加密钱包本质上只是管理**私钥**的工具——私钥是一长串加密字符,用来证明你对区块链上所记录代币的所有权。托管模式有两种:

| 模式 | 谁持有私钥? | 谁能转移你的资金? | 示例 |
|---|---|---|---|
| **托管型** | 公司(交易所、经纪商) | 公司(你则通过公司操作) | Coinbase, Binance, Revolut Crypto |
| **非托管型** | 你自己(在你的设备上) | 只有你 | Lumina Wallet, MetaMask, Phantom, Ledger |

在非托管方案中,你的私钥是**在手机或硬件设备本地生成**的,并通过操作系统的安全模块加密(iOS Secure Enclave、Android Keystore,或硬件钱包中的专用芯片)。钱包应用绝不会把私钥传输到任何地方。即使钱包背后的公司明天消失,只要你仍保管着**12 或 24 个单词的助记词**(BIP-39),你的资金依然可以访问。

## 为什么 2026 年是自我托管之年

三股力量让非托管钱包在 2026 年走向主流:

1. **交易所倒闭已不再罕见。** Chainalysis 报告称,2022–2025 年交易所崩盘中仍有 $2.8B 的用户资金被冻结或损失 [2]。
2. **MiCA 及全球监管推动储备金证明。** 但储备金证明无法防范运营层面的资不抵债——只有自我托管可以。
3. **移动钱包在用户体验上已迎头赶上。** 开通 Binance 账户与设置非托管钱包之间的易用性差距,已缩短到 5 分钟以内。

## 真实的取舍(坦诚版)

选择非托管钱包并非绝对“更好”,而是另一种责任模式。以下是坦诚的取舍:

**你将获得:**
- 直接所有权——没有交易对手风险
- 无需每次操作都做 KYC,即可使用 DeFi、NFT、兑换和质押
- 抗审查能力
- 更低的长期费用(没有托管方的价差)

**你需要接受:**
- **你就是备份。** 一旦丢失 24 个单词的助记词,没有客服能帮你找回资金。
- **你就是安全团队。** 网络钓鱼、恶意签名、假代币——钱包能提供帮助,但最终决定由你来做。
- **无法撤销欺诈交易。** 区块链交易是不可逆的。

选择一款具备**主动反诈骗保护**(签名解码、地址扫描、假代币过滤)的钱包,可以大幅降低安全负担,但这种负担永远不会完全消失。

## 2026 年如何选择非托管钱包

并非所有非托管钱包都一样。“安全”“最安全的钱包”这类营销话术不能作为评估标准。请使用下面这份具体清单:

### 1. 密钥存储:助记词存放在哪里?

- **最低可接受标准(软件钱包):** 密钥存储在 iOS Secure Enclave 或 Android Keystore 中,并通过生物识别或 PIN 码加密。绝不能存放在普通应用存储或云同步中。
- **最高安全级别:** 硬件钱包(Ledger、Trezor、Coldcard)。密钥永远不会离开设备。

### 2. 开源或可验证的透明度

- 优先选择代码公开,或至少发布了知名机构(Trail of Bits、Halborn、Certik)审计报告的钱包。
- 确认钱包背后的公司身份可查。如果钱包由可在公共登记机构(如欧盟公司的 RCS、Companies House)中查证的法律实体运营,就更难卷走你的资金跑路。

### 3. 反诈骗功能(2026 年的差异化关键)

2026 年真正的风险**不是**有人破解你的加密,而是**你签署了一笔恶意交易**。最好的非托管钱包通过以下方式来防止这种情况:

- **地址扫描器**:将每个收款方与已知的钓鱼/制裁名单(GoPlus、Chainalysis、OFAC)进行交叉比对
- **签名解码器**:把 ERC-20 Permit 和 Permit2 签名翻译成通俗易懂的语言
- **假代币过滤器**:避免空投的诈骗 USDT 与真正的 USDT 并排显示
- **交易模拟**:在你签名前显示将从钱包中转出的内容

阅读:[恶意 ERC-20 Permit 骗局](/en/blog/malicious-erc20-permit-scam)和[地址投毒骗局](/en/blog/address-poisoning-crypto-scam)。

### 4. 多链支持,一套助记词

如果钱包能通过同一个 BIP-39 助记词支持 Bitcoin、Ethereum、Solana、XRP 以及主要的 EVM 链,就意味着更少的麻烦,也只需保护更少的助记词。

### 5. 恢复体验

在存入大额资金之前,先测试恢复流程。好的钱包会在首次设置时要求你确认助记词,在你尝试截图时发出警告,并提供清晰的文档说明如何在新设备上恢复。

## 保护你的 10 分钟设置流程

1. 从**官方商店页面**下载钱包(不要点搜索广告——骗子会购买赞助搜索结果)
2. 创建新钱包
3. **把助记词写在纸上或金属备份板上**。绝不要存放在云笔记、截图或带云同步的密码管理器中
4. 在应用中确认助记词
5. 启用生物识别解锁 + PIN 码
6. 先从交易所转入一小笔测试金额($5–10)
7. 确认到账
8. 之后再转入更大金额

## 非托管 vs. 热/冷钱包:你的手机属于哪一类?

“热”与“冷”**不等同于**“托管”与“非托管”:

- **热钱包** = 连接互联网(移动应用、浏览器扩展)
- **冷钱包** = 离线(硬件钱包、纸钱包)
- 移动端非托管钱包是**热钱包,但属于非托管**。
- 硬件钱包是**冷钱包,同时属于非托管**。

对于日常使用(约 $10k 以下),安全的移动端非托管钱包是 2026 年的主流推荐。如果储蓄超过这一数额,请再增加一层硬件钱包保护。

## 非托管加密钱包常见问题

### 非托管钱包合法吗?
合法。在所有主要司法辖区(美国、MiCA 下的欧盟、英国、加拿大、日本、新加坡),持有自己的私钥都是合法的。申报义务适用于**与法币之间的转入/转出**,而不是自我托管本身。请查看你所在地的税务申报规定。

### 使用非托管钱包会损失资金吗?
会,有三种方式:(1)丢失助记词,(2)签署恶意交易,(3)转到错误的地址。这三种情况都可以通过妥善备份和使用具备主动反诈骗功能的钱包来应对。

### Coinbase Wallet 是非托管的吗?
Coinbase Wallet(独立应用)是非托管的。Coinbase **交易所**账户则是托管型的。它们是两款品牌名称相同的不同产品。

### 2026 年最适合新手的非托管钱包是什么?
请参阅我们的专题对比:[2026 年最佳非托管加密钱包](/en/blog/best-non-custodial-crypto-wallet-2026)。简而言之:选择一款内置签名解码和地址扫描、以移动端为先的钱包。

## 结论

非托管加密钱包不是奢侈品——在 2026 年,它是持有超过几百美元加密资产的任何人的基本配置。学习曲线确实存在,但很短。关键决策是:选择具备现代反诈骗保护的钱包,把助记词备份在纸上,先从小额测试转账开始,并把你的助记词当作它本来的样子——一把万能钥匙。

**准备好在内置诈骗防护的保护下实现自我托管了吗?** [在 Google Play 下载 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)。

---

### 参考资料

[1] Electronic Frontier Foundation. (2026). *Self-custody as a digital-rights baseline*. [https://www.eff.org/](https://www.eff.org/)

[2] Chainalysis. (2026). *The State of Centralized Exchange Insolvencies*. [https://www.chainalysis.com/](https://www.chainalysis.com/)`
  },
  "faux-wallets-crypto-2026-7-clones": {
    title: "2026 年假冒加密钱包:需要了解的 7 种新型克隆攻击",
    meta: "2026 年实战指南:解析 7 种最活跃的假冒加密钱包攻击——赞助商店克隆、相似域名、Telegram“客服”钱包、改装 APK、深度伪造创始人视频、假 MetaMask 更新以及助记词恢复骗局,并附防范步骤。",
    body: `2026 年,假冒加密钱包攻击的增长速度超过了其他任何一类加密货币盗窃。Chainalysis 估计,**仅 2026 年上半年,假冒钱包骗局就造成了 3.4 亿美元的损失** [1]。背后的推手是诈骗团伙的专业化运作:付费搜索广告、动态克隆基础设施、深度伪造生成的创始人视频,以及带有助记词窃取载荷的改装版 Android APK。

本文是一份实战指南。针对 2026 年最活跃的 7 种攻击模式,我们逐一说明:攻击如何运作、其中的技术手法,以及能够化解它的那一个关键步骤。

## 1. 赞助商店listing克隆

**运作方式。** 攻击者在 Google Play 或 App Store 上发布与正规钱包几乎一模一样的仿冒应用——图标相同,名称相近(“Lumina Wallet Pro”“MetaMask Lite”“Phantom Wallet Vault”)。随后,他们在 Google 搜索中购买真实钱包品牌名称的赞助广告位,让仿冒应用排在正版之前。

**技术手法。** 仿冒应用运行一套精简的界面,外观与真实钱包相似。在创建或导入助记词时,它会悄悄把助记词上传到攻击者的服务器。用户看到的是标准的“钱包已就绪”界面,而资金正在后台被转走。

**破解方法。** 绝不要通过搜索广告安装钱包。请直接访问厂商的官方域名(手动输入,不要从搜索结果进入),在官网找到应用商店徽标,再点击跳转。Google 官方也建议加密应用采用这种流程 [2]。相关阅读:[假冒加密钱包克隆](/en/blog/fake-crypto-wallet-clones)。

## 2. 相似域名(Punycode 与拼写仿冒)

**运作方式。** 攻击者注册在视觉上与真实域名几乎无法区分的域名——例如“luminawallet.com”对比“lumınawallet.org”(无点 i)、“metamask.io”对比“metamαsk.io”(希腊字母 alpha)、“trustwallet.com”对比“trust-wallet.com”。

**技术手法。** 浏览器地址栏会显示与拉丁字母外观相同的 Unicode 字符(IDN 同形异义字攻击)。许多钱包用户根本察觉不到。

**破解方法。** 始终使用书签访问钱包网页。不要在时间紧迫时手动输入域名。按精确域名匹配的密码管理器会拒绝在相似域名上自动填充——这就是让你立即停下的信号。

## 3. “Telegram 客服”钱包骗局

**运作方式。** 你在某个正规的加密货币群组里发帖抱怨(“我的交易卡住了”)。几分钟内,名为“Lumina Wallet Support”或“MetaMask Help”的账号就会私信你,表示愿意帮忙。对方发来一个“客服后台”链接,要求你连接钱包,或粘贴助记词以“验证所有权”。

**技术手法。** 真正的钱包公司不会以这种方式在 Telegram 上提供客服。骗子使用爬虫机器人监测钱包品牌的提及,并在几秒内发送私信。

**破解方法。** 任何正规的钱包客服都不会索要你的助记词、私钥,也不会要求你连接未知的 dApp。所有真实的客服渠道都可以从官方应用内部找到——而不是由对方主动来找你。参见[假客服加密货币追回骗局](/en/blog/fake-support-crypto-recovery-scams)。

## 4. 改装版 Android APK(侧载攻击)

**运作方式。** 在 Android 上,用户搜索“download MetaMask APK”,并从第三方网站安装了改装版本。该应用的外观和操作都与真实应用一致,但内含拦截助记词生成的载荷。

**技术手法。** 攻击者获取真实的开源 APK,在密钥生成流程中注入恶意代码(使熵值部分受攻击者控制),重新签名,然后发布到 APK 镜像站点。

**破解方法。** 在 Android 上,只从 Google Play 商店安装钱包。默认关闭“安装未知来源应用”。iPhone 用户则天然受到 App Store 沙盒机制的保护。

## 5. 深度伪造创始人视频(赠币骗局)

**运作方式。** YouTube 和 TikTok 上的广告中,“Vitalik Buterin”“Changpeng Zhao”或某钱包的真实创始人宣布“钱包升级赠币活动”。向二维码发送 1 ETH,就能收到 2 ETH 返还。这类视频都是深度伪造的。

**技术手法。** 2026 年的开源模型(SadTalker-v4、HeyGen-OSS、VASA-1 克隆版)仅凭一张照片和一段克隆的语音样本,就能生成口型同步、以假乱真的视频。仅在 2026 年第三季度,Lumina 的分析团队就发现了 23 个冒充主流钱包创始人的不同深度伪造视频。

**破解方法。** 正规钱包绝不会搞“发送 X 返还 2X”的活动,绝对不会。这是 100% 可靠的诈骗信号。另外:相比预先录制的视频,直播的创始人活动更容易验证真伪。

## 6. 假冒“钱包更新”浏览器弹窗

**运作方式。** 你访问任意一个加密货币网站,页面弹出窗口或注入的横幅提示“你的 MetaMask 已过期,点击更新”。链接指向的页面会安装恶意浏览器扩展或改装版钱包。

**技术手法。** 这类弹窗大多来自正规加密货币网站上被入侵的第三方广告网络。真实的钱包绝不会以这种方式提示更新——浏览器扩展通过 Chrome / Firefox 商店更新,移动应用则通过系统应用商店更新。

**破解方法。** 忽略所有页面内的“更新你的钱包”提示。只在浏览器扩展商店或手机应用商店中检查更新。如果提示不依不饶,直接关闭标签页。

## 7. 助记词恢复“迁移”骗局

**运作方式。** 你收到一封邮件、一条短信或应用内私信:“您的钱包正在迁移至新的安全版本。请在此页面重新输入助记词以迁移您的资产。”内容仿冒了你所用真实钱包的品牌样式。

**技术手法。** 这利用了真实钱包偶尔会更换品牌或进行迁移这一事实。攻击者模仿这些合法事件(有时就在真实公司发布公告后的 48 小时内)来降低用户的警惕。

**破解方法。** 任何钱包迁移都不需要你在网页或表单中重新输入助记词。真正的迁移要么在应用内完成,要么只是商店中的一次普通应用更新。如有任何疑问,请直接打开官方应用,查看应用内公告。

## 速查表:2026 年假冒钱包危险信号

| 危险信号 | 实际情况 |
|---|---|
| “输入助记词以验证 / 恢复 / 迁移” | 钓鱼。永远如此。 |
| 钱包品牌名称出现 Google 赞助搜索结果 | 很可能是克隆应用。直接跳过。 |
| 从非 Play 商店网站下载 APK | 改装恶意软件。 |
| 公开抱怨后收到“钱包客服”私信 | 爬虫机器人。举报并拉黑。 |
| 创始人声称“发送 X,收到 2X” | 深度伪造 / 虚假赠币。 |
| 页面内弹窗要求你更新钱包 | 被注入的广告。忽略。 |
| 密码管理器拒绝在该“钱包”域名上自动填充 | 相似域名。停下。 |

## Lumina Wallet 如何防范假冒钱包攻击

Lumina Wallet 整合了本指南中的实用防御措施:

- **安装来源验证** —— 首次启动界面会显示应用的包完整性信息,使改装 APK 可被识别
- **签名解码** —— 来自克隆 dApp 的恶意交易会在签名前以通俗易懂的语言标记出来
- **地址扫描器** —— 收款地址会与已知的钓鱼 / 制裁数据库进行交叉比对
- **助记词可见性警告** —— 应用会检测助记词界面上的截图尝试,并在 Android 上予以拦截

查看完整说明:[Lumina 的安全理念](/en/security)。

## 假冒钱包常见问题

### 假冒钱包仅仅因为被安装就能盗走我的资金吗?
不会立即发生。大多数假冒钱包是在你 (a) 向其中导入现有助记词、(b) 在其中创建新助记词,或 (c) 签署它们构造的交易时才盗取资金。安装后从不使用相对安全——但仍建议卸载。

### 如何确认我当前使用的钱包是正版?
在 Android 上,检查安装来源:设置 → 应用 → [钱包] → 应用信息 → 安装来源。它应显示“Google Play Store”(com.android.vending)。在 iOS 上,从真实 App Store 安装的应用无法通过这种方式被改装,风险较低。此外,还应将发布者名称与真实厂商的域名进行比对。

### 我觉得自己在假冒网站上输入了助记词,现在该怎么办?
立即行动:打开你的正规钱包,将所有代币转入你新创建的全新钱包(使用新助记词)。旧助记词已永久泄露。参见[假客服加密货币追回骗局](/en/blog/fake-support-crypto-recovery-scams)。

### 硬件钱包能免疫这些攻击吗?
基本可以。硬件钱包保护的是密钥,因此即使手机上有假冒的配套应用,也无法将其窃取。不过,由假冒 dApp 构造的恶意交易仍会显示在硬件钱包上,你仍然必须不批准它。请仔细阅读设备屏幕上的内容。

## 结语

2026 年的假冒加密钱包不是业余作案——它们专业、资金充足,而且迭代迅速。防御之道朴素却可靠:只从官方商店安装,绝不在生成助记词的应用之外输入助记词,使用具备签名解码功能的钱包,并为真实域名添加书签。四个习惯,零例外。

**安装 Lumina Wallet —— 仅限官方商店:** [Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)。

---

### 参考资料

[1] Chainalysis. (2026). *Mid-Year Crypto Crime Report 2026 — Fake Wallet Threats*. [https://www.chainalysis.com/](https://www.chainalysis.com/)

[2] Google Safety. (2026). *Crypto Wallet App Safety Guidelines*. [https://safety.google/](https://safety.google/)`
  },
  "checklist-securite-wallet-crypto-2026": {
    title: "2026 年加密钱包安全检查清单",
    meta: "一份务实、不夸张的 2026 年加密钱包用户安全检查清单。共十五项,按设置、日常使用、长期存储和恢复分组——为普通用户而写,而非审计人员。",
    body: `大多数加密钱包"安全提示"文章要么太过技术化(面向审计人员的威胁模型),要么太过笼统("请小心!")。这份清单有所不同:**十五项具体、可验证的操作**,按你在加密之旅中所处的阶段分组,并注明每一项所防范的具体攻击。如果你今年只读一份钱包安全清单,这一份值得打印出来。

## 第一部分——设置(最初 15 分钟)

### 1. 从官方应用商店安装,切勿通过搜索广告安装
**防范:** 付费推广的商店页面克隆应用和被篡改的 APK。
手动输入厂商的真实域名,在该网站上找到应用商店徽章,再点击跳转。切勿从 Google 赞助的搜索结果中安装。

### 2. 核实应用页面上的发布者名称
**防范:** 图标相似的仿冒应用。
在 Google Play 和 App Store 上,发布者名称显示在应用标题下方,必须与你预期的公司一致(例如,Lumina Wallet 对应"HEDONISME SARL")。如果显示的是"Lumina Studios LLC",那就是克隆应用。

### 3. 创建新钱包——不要一换新手机就立刻导入旧钱包
**防范:** 助记词已泄露的情况。
如果你是第一次设置钱包,请生成全新的助记词。只有在确实需要访问这些资金时,才导入已有的助记词。

### 4. 将助记词写在纸上或金属备份板上
**防范:** 云端泄露和截图类恶意软件。
切勿将助记词保存在云笔记(Google Keep、iCloud Notes、Dropbox)、截图、云同步的密码管理器或邮件草稿中。只使用纸张或钢板(Billfodl、Cryptosteel)。

### 5. 在应用中确认助记词,并在存入资金前测试恢复
**防范:** 设置时的输入错误,等发现时往往已为时太晚。
大多数钱包会要求你通过重新选择单词来确认助记词,请务必仔细完成。然后——在转入真实资金之前——删除钱包,并使用你手写的备份恢复一次。如果能正确恢复,说明你的备份有效。

## 第二部分——日常使用

### 6. 使用生物识别 + PIN 码锁定应用
**防范:** 手机在解锁状态下被盗。
两层保护都很重要:生物识别用于日常便利,PIN 码则是在窃贼设法利用你的面部角度时的后备保障。

### 7. 使用带签名解码功能的钱包
**防范:** 恶意的 ERC-20 Permit 和 Permit2 签名。
好的钱包会在你签名之前,将签名内容翻译成通俗易懂的语言("你授权 [未知合约] 花费无限额度的 USDT")。如果你的钱包显示的是原始十六进制数据,请升级。参见我们的深度解析:[恶意 ERC-20 Permit 骗局](/en/blog/malicious-erc20-permit-scam)。

### 8. 启用假代币过滤(或使用默认开启此功能的钱包)
**防范:** 空投骗局,即真正的 USDT 旁边出现一个假的 USDT。
Lumina Wallet 会根据官方合约地址过滤代币。如果你的钱包会显示所有空投,请将每一个意料之外的代币都视为可疑,直到在区块浏览器上证实其真实性。

### 9. 使用链上扫描器验证收款地址
**防范:** 地址投毒和受制裁地址。
现代钱包会针对 GoPlus、Chainalysis 和 OFAC 名单,实时检查每一个转出地址。如果某个地址被标记——请立即停止。阅读:[地址投毒骗局](/en/blog/address-poisoning-crypto-scam)。

### 10. 先向新收款人转一小笔测试金额
**防范:** 输入错误、地址投毒、被钓鱼软件替换的复制粘贴地址。
在任何超过约 $500 的转账之前,先发送约 $5–10。确认它到达了正确的钱包,然后再发送其余金额。

## 第三部分——交易与 dApp

### 11. 切勿签署你不理解的签名
**防范:** 所有基于签名的资产盗取(Permit、Permit2、SeaportOrder、ERC-721 授权)。
如果钱包或 dApp 向你展示的签名请求包含含义不明的字段,请不要签名。在 2026 年,**没有任何正当理由**去签署一个不透明的签名。

### 12. 将"无限授权"视为危险信号
**防范:** 永远有效的无限额度授权。
当 dApp 请求授权 ERC-20 代币时,优先选择"自定义金额"(仅限本次交易的金额),而不是"无限"。请定期通过 Revoke.cash 或钱包自带的授权管理器检查并撤销旧的无限授权。

### 13. 断开不再使用的 dApp 连接
**防范:** 休眠权限日后被利用。
每个钱包都有"已连接网站"或"已连接应用"的视图。如果你不认识某个连接,请将其断开。每月做一次,只需 30 秒。

## 第四部分——长期存储与恢复

### 14. 对超出"心理底线"的金额使用硬件钱包
**防范:** 设备端恶意软件窃取密钥。
每个人对"这些钱被盗我会非常难受"的门槛各不相同。对大多数 2026 年的用户来说,这条线大约在 $5k 到 $20k 之间。超过这个金额,花约 $70–$150 购买硬件钱包是值得的。

### 15. 将资产分散在至少两个钱包中
**防范:** 单个钱包被攻破导致全部资产损失。
将"消费钱包"(移动端,便捷,金额较小)与"储蓄钱包"(硬件钱包或备份完善的深度冷存储软件钱包)分开。两者之间的转账应当很少发生,且是经过深思熟虑的。

## 可打印摘要

| # | 操作 | 防范 |
|---|---|---|
| 1 | 从官方应用商店安装 | 商店页面克隆应用 |
| 2 | 核实发布者名称 | 仿冒应用 |
| 3 | 创建新钱包 | 已泄露的助记词 |
| 4 | 纸质/金属备份 | 云端泄露 |
| 5 | 存入资金前测试恢复 | 设置时的输入错误 |
| 6 | 生物识别 + PIN 码 | 手机被盗 |
| 7 | 签名解码器 | Permit/Permit2 盗取 |
| 8 | 假代币过滤 | 空投骗局 |
| 9 | 链上地址扫描器 | 地址投毒 |
| 10 | 小额测试转账 | 输入错误、投毒 |
| 11 | 不签署不透明的签名 | 所有签名类骗局 |
| 12 | 避免无限授权 | 无限额度盗取 |
| 13 | 断开未使用的 dApp | 休眠权限漏洞利用 |
| 14 | 用硬件钱包存储储蓄 | 设备恶意软件 |
| 15 | 区分消费与储蓄钱包 | 单个钱包被攻破 |

## Lumina Wallet 如何覆盖这份清单

第 6–11 项和第 13 项已默认内置于 Lumina Wallet 中——无需任何配置。第 1–5 项、第 12 项、第 14 项和第 15 项取决于你个人的习惯,任何钱包都无法替你强制执行。

查看完整的功能介绍:[Lumina Wallet 功能](/en/features)和[安全理念](/en/security)。

## 加密钱包安全常见问题

### 我应该多久回顾一次这份清单?
每 6 个月完整重读一次就足够了。快速项目(第 3、9、13 项)值得在每笔超过 $500 的新交易之前执行。

### 密码管理器可以安全地保存助记词吗?
只有在密码管理器完全没有云同步(仅本地保险库)且设备已加密的情况下才可以。对大多数用户而言,纸张或金属更简单也更安全。云同步的密码管理器 = 云端 = 不适合存放助记词。

### 如果我的手机在钱包未锁定时被盗了怎么办?
如果你已落实第 6 项(生物识别 + PIN 码)和第 15 项(分散资产),你的消费钱包风险有限,储蓄钱包则不受影响。即便如此,仍应立即通过另一台设备撤销 dApp 连接;如果你持有助记词,请将资产转出到新钱包。

### 2026 年基于浏览器的加密活动仍然安全吗?
可以安全,前提是使用信誉良好的扩展钱包、专用的浏览器配置文件,并严格审查签名。但其攻击面比移动端更大。对大多数普通用户来说,内置防护的移动钱包是 2026 年更好的默认选择。

## 结语

2026 年的加密钱包安全,90 % 靠习惯,10 % 靠技术。技术层面固然重要——具备签名解码、地址扫描和假代币过滤功能的钱包,能封堵那些仅凭自律无法防范的攻击。但上述十五项习惯,才是让用户高枕无忧、而不是在惨痛教训中才学会助记词安全的关键所在。

**体验内置第 6–11 项和第 13 项功能的钱包:** [Google Play 上的 Lumina Wallet](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)。

---

### 参考资料

[1] NIST. (2026). *Digital Identity Guidelines — Cryptographic Key Management for Consumer Wallets*. [https://www.nist.gov/](https://www.nist.gov/)

[2] GoPlus Labs. (2026). *2026 Crypto Threat Intelligence Report*. [https://gopluslabs.io/](https://gopluslabs.io/)`
  },
  "verifier-app-wallet-crypto-authentique": {
    title: "如何判断加密钱包应用是否为正版:2026 年验证清单",
    meta: "安装加密钱包应用之前,请先做这些检查:官方链接、发布者、应用 ID、权限以及助记词行为。一份 5 分钟清单,帮你识别假冒钱包应用。",
    body: `假冒钱包应用是损失加密资产最简单的途径之一:你安装了一个看起来很正常的钱包,创建或导入了助记词,而这个应用却悄悄把助记词发给了骗子。没有黑客攻击,也没有漏洞利用,只是装错了应用。

好消息是:大多数假冒钱包应用都经不起几项基本检查。本指南为你提供一套**约五分钟即可完成的验证流程**,适用于安装任何钱包之前,Lumina Wallet 也不例外。

> 已经了解主要的警示信号了吗?我们的指南 [假冒加密钱包:如何识别克隆应用](/zh/blog/faux-wallets-crypto-clones) 解释了克隆应用的运作方式。本文则是实用的检查清单。

## 第 1 步:从官方网站入手,而不是搜索广告

假冒钱包最常见的入口是**赞助搜索结果**,或是出现在正版结果上方的广告。骗子会针对钱包名称购买广告,因为人们会搜索这些名称。

- 亲自输入官方网站地址,或使用你之前保存的书签。
- 使用该网站上发布的下载链接,而不是搜索引擎或社交网络上的第一个链接。
- 警惕外观相似的域名:多一个字母、不同的后缀(.app、.io、.net),或看起来完全一样的字符(例如用 "rn" 代替 "m")。

对于 Lumina Wallet,官方下载链接列在[下载页面](/zh/download)上。

## 第 2 步:在商店页面核对发布者

在 App Store 或 Google Play 上打开应用页面,查看**开发者/发布者名称**,而不仅仅是应用名称和图标,因为后两者很容易被复制。

- 发布者应与官方网站背后的公司或项目一致。
- 点开发布者名称:真正的钱包团队通常有连贯的发布历史,而不是一堆上周才发布、互不相关的应用。
- 阅读最新的评价。若有多条评价提到"导入后资金消失",这是强烈的警示信号。短短几天内出现大量笼统的五星好评,同样可疑。

## 第 3 步:比对应用标识符

每个应用都有唯一的标识符,克隆应用无法在官方商店中重复使用:

- **Android:**Google Play 链接中 \`id=\` 之后的包名。
- **iOS:**App Store 链接中 \`/id\` 之后的数字 ID。

将其与官方网站链接中的标识符进行比对。如果官网指向的是一个 ID,而你找到的应用是另一个,那它就不是同一个应用。

## 第 4 步:切勿安装他人发给你的钱包文件

通过 Telegram、Discord、WhatsApp 或电子邮件分享的 APK 文件安装钱包,会完全绕过商店的审核。钱包的"改版"、"专业版"或"解锁版"是经典陷阱。

- 只通过官方网站提供的链接,从官方商店安装钱包。
- 如果有人坚持要你安装某个特殊版本来"修复你的账户",请将其视为骗局。我们关于[假冒客服与找回资产骗局](/zh/blog/faux-support-arnaques-recuperation-crypto)的文章介绍了这种套路。

## 第 5 步:检查权限(Android)

钱包应用需要的权限很少:网络访问,有时还需要相机来扫描二维码。如果钱包要求以下权限,请保持怀疑:

- **无障碍服务**(可以读取并控制屏幕上的内容),
- **显示在其他应用上层**(可以在真实界面上方显示虚假界面),
- **短信访问**或**设备管理员**权限。

发送或接收加密资产并不需要其中任何一项。

## 第 6 步:留意应用如何处理你的助记词

这是最重要的检查,因为骗子想要的正是助记词。

- 正规的非托管钱包会在你创建新钱包时,于你的设备上**生成**助记词,并要求你离线抄写。
- 它绝不会要求你把助记词发给"客服",在网站上"验证"或"同步",或输入助记词来"解锁"奖励。
- 如果应用一上来就要求你导入已有助记词,并施加压力("你的钱包将被冻结"),请立即停止。

拿不准时,请在应用中**创建一个新钱包**,而不是导入你的主助记词,并先进行测试。

## 第 7 步:先用小额测试

在转入大额资金之前:

1. 向新钱包发送一小笔资金。
2. 在公共区块浏览器上查看这笔交易。
3. 将其中一部分转回你自己控制的地址。

如果出现任何异常,例如余额不显示、地址意外变化、要求支付"手续费"来解锁资金,请立即停止使用该应用。

## 5 分钟清单

| 检查项 | 正版应用的表现 |
| --- | --- |
| 来源 | 链接取自官方网站,而非广告或消息 |
| 发布者 | 与官方网站为同一主体,发布历史连贯 |
| 应用标识符 | 与官方网站链接的 ID 一致 |
| 安装方式 | 仅限官方商店,绝不使用他人发来的 APK 文件 |
| 权限 | 没有无障碍、悬浮窗、短信或管理员权限 |
| 助记词 | 在本地生成,绝不会被"客服"或网站索要 |
| 首次使用 | 转入较大金额之前先做小额测试交易 |

## 如果你安装了假冒钱包该怎么办

如果你已在一个现在让你起疑的应用中输入了助记词,请假定该助记词已经泄露:

1. **迅速行动。**在你信任的设备上,从官方渠道安装正版钱包,并使用新的助记词创建一个**新**钱包。
2. 将资金从旧地址**转移**到新钱包。
3. 使用信誉良好的授权检查工具**查看**与旧地址关联的代币授权,并撤销你不认识的授权。
4. **卸载假冒应用**,并向应用商店举报。
5. **不要理会任何声称收费帮你找回资金的人**:这类提议几乎都是第二次骗局。

## 常见问题

**假冒钱包应用会出现在官方商店中吗?**
会,这种情况确实存在:一些克隆应用在被下架之前会通过审核并存在一段时间。因此,核对发布者和应用标识符很重要,不能只看是否来自商店。

**下载量很大的钱包一定是正版吗?**
不一定。下载量和评价都可能被刷高。请把它们当作众多信号之一,而绝不能当作证据。

**Lumina Wallet 会索要我的助记词吗?**
不会。Lumina Wallet 是非托管钱包:你的助记词只保存在你的设备上,Lumina 的任何人都不会向你索取。

**安装钱包之后,如何保证它的安全?**
请参考我们的 [2026 年加密钱包安全清单](/zh/blog/checklist-securite-wallet-crypto-2026),了解设置、日常使用和恢复的相关内容。

## 结论

假冒钱包应用只有在你跳过基本检查时才会得逞。从官方网站获取链接,比对发布者和应用标识符,拒绝陌生人发来的文件,并且永远不要把助记词交给任何人。五分钟的验证,远比丢失钱包划算得多。

要安装 Lumina Wallet,请使用官方[下载页面](/zh/download)上的链接。`
  },
  "crypto-volees-que-faire": {
    title: "以太坊诈骗追回指南:加密资产被盗后你真正能做什么(2026)",
    meta: "加密资产被诈骗盗走了?以下是前 24 小时内你切实可行的做法:保护钱包、保存证据、追踪资金、向警方、交易所和稳定币发行方报案,并避开追回类骗局。",
    body: `如果你的 ETH 或代币因诈骗、钓鱼网站或恶意签名而被盗,最初的几个小时至关重要。本指南将说明**你切实可行的做法**、操作顺序,以及如何避免被那些在失窃后立刻盯上受害者的"追回专家"骗走更多钱。

首先要坦率地说明一点:区块链交易无法撤销。没有任何人——无论是你的钱包、以太坊,还是 Lumina Wallet——能够按下一个按钮就让交易回滚。追回有时是可能的,但只有特定的途径:由交易所或稳定币发行方冻结资金,通常需要在正式报案之后。

## 第 1 步:止损(最初几分钟)

在尝试追回任何资产之前,先保护好剩下的资产。

- **不要再向任何人转账**,无论对方承诺"解锁"、"释放"还是"追回"你的资金。
- 如果你的**助记词(恢复短语)**可能已经泄露(你在某个网站上输入过、在现在让你起疑的应用中输入过,或者把它交给了"客服"),请在你信任的设备上创建一个**使用全新助记词的新钱包**,并把剩余资金转移过去。
- 如果被盗源于**恶意授权或签名**,请使用信誉良好的授权检查工具(例如 Etherscan 上的代币授权工具)查看你地址的代币授权,并撤销你不认识的授权。在授权被撤销之前,盗币程序(drainer)可以持续利用该授权。
- 断开钱包与相关网站的连接,并卸载任何可疑的应用或浏览器扩展。

## 第 2 步:收集证据

之后的每一步都依赖准确的信息。请记录或保存:

- 被盗转账的**交易哈希**(TxID);
- 你的地址以及**收款地址**;
- 日期、时间和金额;
- 涉及的网站 URL、应用名称、社交媒体账号和用户名;
- 聊天记录、广告、邮件以及你使用过的页面的截图。

保留原始消息:不要删除与骗子的聊天记录。

## 第 3 步:在区块浏览器上追踪资金

把交易哈希粘贴到 Etherscan 等区块浏览器中,查看资金接下来流向了哪里:

- 如果资金流向了被标记为**中心化交易所**的地址(某知名平台的充值地址),这是最有价值的线索:受监管的交易所可以冻结账户,通常是应警方的要求。
- 如果被盗资产是 **USDT 或 USDC**,其发行方在技术上有能力冻结某个地址中持有的代币,通常是与执法部门合作进行。速度很关键,因为骗子往往会迅速将其兑换。
- 如果资金经过了**混币器**或大量中间地址,追回会变得困难得多。但仍然要报案。

你不必成为专家:交易哈希和收款地址就是调查人员和交易所会要求你提供的信息。

## 第 4 步:正式报案

正式报案是冻结资金的前提。请尽快提交:

- **你所在国家的警方**,或其网络犯罪举报服务(在美国为 FBI 的 IC3,网址 ic3.gov)。请索取报案回执或编号。
- **收到资金的交易所**:通过其官方网站或应用联系官方客服(切勿通过别人发给你的链接),并提供交易哈希和你的警方报案编号。
- **稳定币发行方**(如果被盗的是 USDT 或 USDC):通过其官方网站联系。
- **公共诈骗数据库**,例如 Chainabuse,以便提醒其他用户注意相关地址。
- **你结识骗子的平台**(社交网络、应用商店、广告网络),以便相关账号、应用或广告被下架。

## 第 5 步:警惕"追回专家"

失窃之后,受害者常常会被一些人联系,他们声称可以"反向黑客入侵"、"追踪并追回"或"解锁"被盗的加密资产,但要先收取预付费用。实际上,这类提议是一种众所周知的二次诈骗。

危险信号:

- 他们主动联系你,通常是在你发布被盗经历后,通过评论或私信找上门;
- 他们保证结果,或给出精确的成功率;
- 他们要求你预付费用,或收取"税费"、"gas 费"或"解冻费";
- 他们索要你的助记词或对你设备的远程访问权限。

真正的执法部门绝不会向你收费来追回资金。如果你想寻求专业帮助,请选择持牌律师或信誉良好、身份可核实的区块链调查公司,并且绝不要向主动联系你的陌生人付款。我们的文章 [加密资产追回骗局与虚假客服](/zh/blog/faux-support-arnaques-recuperation-crypto) 详细介绍了这些骗术。

## 前 24 小时一览

| 时间 | 该做什么 |
| --- | --- |
| 最初几分钟 | 停止向任何人付款,保护剩余资金,撤销可疑授权 |
| 第一小时 | 保存交易哈希、地址、URL 和截图 |
| 最初几小时 | 在区块浏览器上追踪资金,识别交易所或稳定币 |
| 当天 | 向警方报案,通过官方渠道联系交易所和发行方 |
| 之后几天 | 公开举报相关地址,无视主动找上门的"追回"服务 |

## 追回加密资产的几率有多大?

坦率地说,几率有限,并且取决于资金的流向。资金被冻结或返还的案例通常同时具备三点:受害者反应迅速,资金进入了受监管的交易所或可冻结的稳定币,并且已经正式报案。如果这三点都不满足,追回的情况很少见。

这正是预防如此重要的原因:一旦恶意交易被签名,就没有撤销键。

## 如何避免再次发生

- 检查你签署的内容:大多数盗币都始于一次授权、一个 permit 或一笔你没有完全理解的交易。Lumina Wallet 会在你签名前分析交易,并就已知风险向你发出警告,但没有任何工具能拦截一切——也没有任何钱包能在事后撤销交易。
- 只从官方渠道安装钱包:请参阅 [如何判断加密钱包应用是否为正版](/zh/blog/verifier-app-wallet-crypto-authentique)。
- 按照 [加密钱包安全检查清单](/zh/blog/checklist-securite-wallet-crypto-2026) 将你的储蓄与日常使用的钱包分开。

## 常见问题

**被盗的以太坊交易可以撤销吗?**
不能。已确认的交易是不可更改的。唯一现实的途径是由交易所或稳定币发行方冻结资金,通常需要在正式报案之后。

**我应该向承诺帮我追回加密资产的服务付费吗?**
务必极其谨慎。主动找上门、要求预付费用或保证结果的提议是已知的骗局。真正的调查应通过警方、相关交易所或经过核实的持牌专业人士进行。

**金额很小也值得报案吗?**
值得。报案有助于调查人员将案件串联起来,而在诈骗数据库上的公开举报可以就相同的地址提醒其他用户。

**Lumina Wallet 能追回我被盗的资金吗?**
不能。Lumina Wallet 是非托管钱包,无法撤销或冻结交易。它可以帮助你保护一个新钱包,并在你签名前检查未来的交易。

## 结论

加密资产被盗后:保护好剩下的资产,保存证据,追踪资金,通过官方渠道报案,并拒绝一切主动找上门的付费"追回"服务。速度和正式报案能给你最大的机会——而且这两者都不需要花钱。`
  }
};

export default zh;
